<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 0px" color="black">
              <span class="login-title">
                <img
                  :src="empresa.logoUrl"
                  width="100%"
                  style="max-width: 80px"
                />
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px">
                <v-container fluid grid-list-md style="padding: 0px">
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                    <v-container>
                      <v-row dense>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          lg="4"
                          v-for="evento in eventos"
                          :key="evento.id"
                        >
                          <v-card
                            elevation="3"
                            class="mx-auto"
                            style="
                              border-radius: 12px;
                              overflow: hidden;
                              transition: transform 0.3s;
                              height: 100%;
                            "
                            hover
                          >
                            <div
                              v-if="evento.exibePorcentagem"
                              style="
                                margin: 0px;
                                text-align: center;
                                background-color: rgba(244, 67, 54, 0.9);
                                color: white;
                                padding: 8px 0;
                                font-weight: bold;
                                font-size: 14px;
                              "
                            >
                              <span v-if="evento.exigePagamento"
                                >{{
                                  (
                                    (evento.quantidadeInscricoes * 100) /
                                    evento.vagas
                                  ).toFixed(0)
                                }}% VENDIDOS</span
                              >
                              <span v-else
                                >{{
                                  (
                                    (evento.quantidadeInscricoes * 100) /
                                    evento.vagas
                                  ).toFixed(0)
                                }}% VENDIDOS</span
                              >
                            </div>
                            <v-img
                              class="mx-auto"
                              contain
                              width="100%"
                              :src="evento.urlCapa"
                            ></v-img>
                            <v-card-title
                              class="py-2 text-h6 font-weight-medium"
                              style="line-height: 1.2"
                              >{{ evento.nome }}</v-card-title
                            >
                            <v-card-text class="pt-0">
                              <div class="d-flex align-center mb-2">
                                <v-icon color="#00695C" class="mr-2"
                                  >mdi-calendar</v-icon
                                >
                                <span>{{ formatDateHora(evento.inicio) }}</span>
                              </div>
                              <div
                                class="d-flex align-start mb-3"
                                v-if="evento.local"
                              >
                                <v-icon color="#00695C" class="mr-2 mt-1"
                                  >mdi-map-marker</v-icon
                                >
                                <div>
                                  <span>{{ evento.local }}</span>
                                  <span v-if="evento.localizacao">
                                    (<a
                                      :href="evento.localizacao"
                                      target="_blank"
                                      class="primary--text text-decoration-underline"
                                      >Ver no mapa</a
                                    >)
                                  </span>
                                </div>
                              </div>
                              <v-divider class="mb-3"></v-divider>
                              <div class="evento-descricao mb-3" v-if="evento.descricao">
                                <div class="descricao-container" :class="{ 'expandida': isDescricaoExpandida(evento.id) }">
                                  <span v-html="mostrarDescricaoResumida(evento)" class="descricao-texto"></span>
                                </div>
                                <div v-if="evento.descricao && evento.descricao.length > 150" class="text-center mt-2">
                                  <v-btn 
                                    x-small 
                                    outlined
                                    rounded
                                    color="#00695c" 
                                    @click="toggleDescricao(evento.id)" 
                                    class="text-none font-weight-medium px-3"
                                    height="24"
                                  >
                                    {{ isDescricaoExpandida(evento.id) ? 'Ver menos' : 'Ver mais' }}
                                    <v-icon right size="16" class="ml-1">{{ isDescricaoExpandida(evento.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                  </v-btn>
                                </div>
                              </div>
                              <div
                                v-if="
                                  evento.exigePagamento &&
                                  !evento.valorPix &&
                                  !evento.valorCartao
                                "
                              >
                                <div class="d-flex align-center mb-2">
                                  <v-icon color="#00695C" class="mr-2"
                                    >mdi-ticket-confirmation</v-icon
                                  >
                                  <span class="font-weight-medium"
                                    >Setores disponíveis:</span
                                  >
                                </div>
                                <div
                                  v-for="valor in evento.setores"
                                  :key="valor.nome"
                                  class="pl-6 mb-1"
                                >
                                  <div class="d-flex align-center">
                                    <v-icon
                                      :color="valor.cor"
                                      size="12"
                                      class="mr-2"
                                      >mdi-circle</v-icon
                                    >
                                    <span
                                      :style="'color: ' + valor.cor"
                                      class="font-weight-medium"
                                      >{{ valor.nome }}:</span
                                    >
                                    <span class="ml-1"
                                      >R$ {{ valor.valor }}</span
                                    >
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="
                                  !evento.exigePagamento &&
                                  !evento.valorPix &&
                                  !evento.valorCartao
                                "
                              >
                                <div class="d-flex align-center mb-2">
                                  <v-icon color="#00695C" class="mr-2"
                                    >mdi-ticket-confirmation</v-icon
                                  >
                                  <span class="font-weight-medium"
                                    >Ingressos:</span
                                  >
                                </div>
                                <div
                                  v-for="valor in evento.setores"
                                  :key="valor.nome"
                                  class="pl-6 mb-1"
                                >
                                  <span
                                    >{{ valor.nome }}: R$
                                    {{ valor.valor }}</span
                                  >
                                </div>
                              </div>
                              <div
                                v-if="evento.valorPix && evento.valorCartao"
                                class="price-section"
                              >
                                <v-card color="#f5f5f5" flat class="pa-3 mb-2">
                                  <div class="d-flex align-center mb-1">
                                    <img
                                      src="../../assets/pixnew.png"
                                      width="24"
                                      height="24"
                                      alt="Pix"
                                      class="mr-2"
                                    />
                                    <span class="font-weight-medium">Pix:</span>
                                    <div class="ml-auto">
                                      <span
                                        v-if="
                                          indicacao &&
                                          divulgador.aplicaDesconto &&
                                          evento.usaLinkDesconto
                                        "
                                      >
                                        <div
                                          class="text-decoration-line-through grey--text"
                                        >
                                          R$
                                          {{
                                            evento.vendaMinima > 1
                                              ? (
                                                  parseFloat(
                                                    evento.valorPix.replace(
                                                      ",",
                                                      "."
                                                    )
                                                  ) * evento.vendaMinima
                                                ).toLocaleString("pt-BR", {
                                                  style: "currency",
                                                  currency: "BRL",
                                                })
                                              : evento.valorPix
                                          }}
                                        </div>
                                        <div
                                          class="success--text font-weight-bold"
                                        >
                                          R$
                                          {{
                                            calculaValorComDesconto(
                                              evento.vendaMinima > 1
                                                ? (
                                                    parseFloat(
                                                      evento.valorPix.replace(
                                                        ",",
                                                        "."
                                                      )
                                                    ) * evento.vendaMinima
                                                  ).toFixed(2)
                                                : evento.valorPix
                                            )
                                          }}
                                          <v-chip
                                            x-small
                                            dark
                                            color="success"
                                            class="ml-1"
                                            >{{ divulgador.valorDesconto }}%
                                            OFF</v-chip
                                          >
                                        </div>
                                      </span>
                                      <span v-else>
                                        R$
                                        {{
                                          evento.vendaMinima > 1
                                            ? (
                                                parseFloat(
                                                  evento.valorPix.replace(
                                                    ",",
                                                    "."
                                                  )
                                                ) * evento.vendaMinima
                                              ).toLocaleString("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                              })
                                            : evento.valorPix
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    v-if="evento.vendaMinima > 1"
                                    class="text-caption grey--text mt-1"
                                  >
                                    Valor para
                                    {{ evento.vendaMinima }} ingressos
                                  </div>
                                </v-card>
                                <v-card color="#f5f5f5" flat class="pa-3">
                                  <div class="d-flex align-center">
                                    <v-icon color="#00695C" class="mr-2"
                                      >mdi-credit-card</v-icon
                                    >
                                    <span class="font-weight-medium"
                                      >Cartão:</span
                                    >
                                  </div>
                                  <div class="mt-1 text-right">
                                    <span
                                      v-if="
                                        indicacao &&
                                        divulgador.aplicaDesconto &&
                                        evento.usaLinkDesconto
                                      "
                                    >
                                      <div
                                        class="text-decoration-line-through grey--text"
                                      >
                                        em até {{ evento.quantidadeParcelas }}x
                                        de
                                        {{
                                          calculaParcelas(
                                            evento,
                                            evento.vendaMinima > 1
                                              ? evento.vendaMinima
                                              : inscricao
                                              ? inscricao.length
                                              : 1
                                          )
                                        }}
                                      </div>
                                      <div
                                        class="success--text font-weight-bold"
                                      >
                                        em até {{ evento.quantidadeParcelas }}x
                                        de
                                        {{
                                          calculaParcelasComDesconto(
                                            evento,
                                            evento.vendaMinima > 1
                                              ? evento.vendaMinima
                                              : inscricao
                                              ? inscricao.length
                                              : 1
                                          )
                                        }}
                                        <v-chip
                                          x-small
                                          dark
                                          color="success"
                                          class="ml-1"
                                          >{{ divulgador.valorDesconto }}%
                                          OFF</v-chip
                                        >
                                      </div>
                                    </span>
                                    <span v-else>
                                      em até {{ evento.quantidadeParcelas }}x de
                                      {{
                                        calculaParcelas(
                                          evento,
                                          evento.vendaMinima > 1
                                            ? evento.vendaMinima
                                            : inscricao
                                            ? inscricao.length
                                            : 1
                                        )
                                      }}
                                    </span>
                                  </div>
                                  <div
                                    v-if="evento.vendaMinima > 1"
                                    class="text-caption grey--text mt-1"
                                  >
                                    Valor para
                                    {{ evento.vendaMinima }} ingressos
                                  </div>
                                </v-card>
                              </div>
                            </v-card-text>
                            <v-card-actions class="px-4 pb-4">
                              <v-btn
                                block
                                color="#00695C"
                                :disabled="
                                  evento.quantidadeInscricoes >= evento.vagas
                                "
                                @click="realizarInscricaoGrupo(evento)"
                                elevation="2"
                                height="44"
                                class="white--text text-transform-none font-weight-bold"
                                style="border-radius: 8px; transition: all 0.3s"
                              >
                                <v-icon left>mdi-cart</v-icon>
                                Comprar agora
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      style="
                        text-align: center;
                        padding: 0px 10px 0px 10px;
                        margin-bottom: 17px;
                      "
                    >
                      <v-card flat>
                        <img
                          style="margin-right: 5px"
                          src="../../assets/site-seguro-blindado.png"
                          width="300px"
                        />
                      </v-card>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      v-if="empresa.telefone"
                      style="padding: 0px 10px 0px 10px"
                    >
                      <v-btn
                        depressed
                        block
                        style="border-radius: 7px"
                        large
                        :href="
                          'https://wa.me/55' +
                          empresa.telefone +
                          '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' +
                          empresa.nome +
                          '?'
                        "
                        target="_blank"
                      >
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12 style="text-align: justify; text-justify: inter-word">
                      <br>
                      <p style="text-align: center; font-weight: bold; color: white">BARBER PRO NORDESTE</p>
                      <p style="color: white">EVENTO REALIZADO PELA EMPRESA SG EVENTOS (BARBER PRO NORDESTE) DIRECIONADO PARA O RAMO DA BARBEARIA. OPORTUNAMENTE IREMOS REALIZAR A NOSSA 5ª EDIÇÃO NA CIDADE DE FORTALEZA – CE, NO CENTRO DE EVENTOS, LOCALIZADO NA AV. WASHINGTON SOARES, 999 - EDSON QUEIROZ, FORTALEZA - CE, NA DATA 13 DE OUTUBRO DE 2024.</p>
                      <p style="color: white">TENDO INICIO O CREDENCIAMENTO AS 7:30HRS</p>
                      <p style="color: white">INICIO DO EVENTO 9:00HRS</p>
                      <p style="color: white">INTERVALO PARA ALMOÇO DE 12:30 ÀS 13:30</p>
                      <p style="color: white">TÉRMINO DO EVENTO 19:00HRS</p>
                      <p style="color: white">OBS: OBRIGATÓRIO PARA CREDENCIAMENTO APRESENTAÇÃO DO INGRESSO ONLINE E/OU IMPRESSO + DOCUMENTO COM FOTO VISANDO IDENTIFICAÇÃO.</p>
                      <p style="text-align: center; font-weight: bold; color: white">WORKSHOP</p>
                      <p style="color: white">O OBJETIVO DESTE EVENTO É TRAZER DE FORMA PRÁTICA E SUCINTA POR MEIO DE PALESTRANTES QUALIFICADOS, O CONHECIMENTO ESPECÍFICO PARA OS PROFISSIONAIS DO SEGMENTO DA BARBEARIA, COMO:</p>
                      <p style="color: white">TÉCNICAS DE CORTE DE CABELO ATUAIS, VISÃO EMPREENDEDORA, CONHECIMENTO NA ÁREA DE VENDAS DE SERVIÇOS E PRODUTOS, CONHECIMENTO NO TOCANTE DA PARTE DE GESTÃO ADMINISTRATIVA E FINANCEIRA DE SUA BARBEARIA.</p>
                      <p style="color: white">PALESTRANTES:</p>
                      <p style="color: white">1. SEU ELIAS: UMA DAS MAIORES REFERÊNCIAS NO MUNDO DA BARBEARIA MODERNA; EMPREENDEDOR, PROPRIETÁRIO DE 10 BARBEARIAS (SEU ELIAS) EM BELO HORIZONTE - MG; PROPRIETÁRIO DA MARCA DE COSMÉTICOS BABOON, ESTA MARCA SENDO DIRECIONADA PARA O SEGMENTO PROFISSIONAL DA BARBEARIA; DIRETOR DA ACADEMIA PROFISSIONALIZANTE BARBER DAY ACADEMY, SENDO ESTA UMA DAS MAIORES ACADEMIAS FORMADORAS DE PROFISSIONAIS BARBEIROS DO BRASIL.</p>
                      <p style="color: white">2. DANILO MORETI: REFERÊNCIA COMO EDUCADOR PROFISSIONAL, DIRETOR CRIATIVO DO BARBERDAY ACADEMY, EDUCADOR DO CURSO VISAGE. PROFISSIONAL ESPECIALISTA EM TÉCNICAS DE CORTE NA MÁQUINA E NA TESOURA ASSIM COMO ACABAMENTO CRIATIVO E FINALIZAÇÕES.</p>
                      <p style="color: white">3. MICHAEL OLIVEIRA: GESTOR DO GRUPO SEU ELIAS; RESPONSÁVEL PELO SETOR FINANCEIRO E POR TODA A PARTE DE GESTÃO ADMINISTRATIVA DAS BARBEARIAS SEU ELIAS.</p>
                      <p style="text-align: center; font-weight: bold; color: white">REGRA DE CANCELAMENTO</p>
                      <p style="color: white">FICA ESTABELECIDO QUE PARA O CANCELAMENTO DO SEU INGRESSO, O MESMO FICA DISPONÍVEL SOMENTE ATÉ A DATA DO DIA 03/10/2024 PARA ESTE PROCEDIMENTO DEVE SER FEITO O CONTATO COM O NOSSO ATENDIMENTO NA PLATAFORMA (BOTÃO DÚVIDAS? FALE CONOSCO). VOCÊ DEVE TER EM MÃOS TODOS AS INFORMAÇÕES DO SEU INGRESSO (MEDIANTE SOLICITAÇÃO DE PRINT). OBSERVANDO QUE SERÁ COBRADA TAXA DE R$ 45,00 REFERENTE A PROCEDIMENTOS ADMINISTRATIVOS DA EMPRESA.</p>
                    </v-flex> -->
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    v-else-if="eventos.length == 0"
                  >
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>

        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid>
                  <v-row justify="space-between" align="center" class="mb-3">
                    <v-col cols="auto">
                      <v-btn
                        text
                        color="#00695C"
                        @click="cancelarPagamento"
                        class="px-2"
                      >
                        <v-icon left size="20">mdi-arrow-left</v-icon>
                        <span class="font-weight-medium">Voltar</span>
                      </v-btn>
                    </v-col>

                    <v-col cols="auto">
                      <div class="d-flex align-center">
                        <v-chip
                          color="#E0F2F1"
                          text-color="#00695C"
                          small
                          class="font-weight-medium"
                        >
                          <v-icon left size="16" color="#00695C"
                            >mdi-credit-card-outline</v-icon
                          >
                          Pagamento com Cartão
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="indicacao">
                    <v-col cols="12">
                      <v-alert
                        dense
                        color="#E0F2F1"
                        border="left"
                        colored-border
                        class="mb-4"
                        elevation="1"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="#00695C" class="mr-2">mdi-tag</v-icon>
                          <span class="text-body-2">
                            Você está usando o link do divulgador
                            <strong>{{ this.divulgador.nome }}</strong>
                          </span>
                        </div>
                      </v-alert>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="mb-0 pb-0">
                      <v-chip
                        x-small
                        color="#E0F2F1"
                        text-color="#00695C"
                        class="mb-2"
                      >
                        <v-icon left size="12" color="#00695C"
                          >mdi-credit-card</v-icon
                        >
                        <span class="text-caption">Dados do cartão</span>
                      </v-chip>
                    </v-col>

                    <v-col cols="12" md="8" class="pt-0">
                      <v-text-field
                        v-model="pagamento.nomeTitular"
                        label="NOME IMPRESSO NO CARTÃO"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('nomeCartao')"
                        data-vv-name="nomeCartao"
                        prepend-inner-icon="mdi-card-account-details-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4" class="pt-0">
                      <v-text-field
                        v-model="pagamento.cartaoNumero"
                        v-mask="maskCartao"
                        label="NÚMERO DO CARTÃO"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('numCartao')"
                        data-vv-name="numCartao"
                        prepend-inner-icon="mdi-credit-card-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field
                        v-model="pagamento.cpfTitular"
                        v-mask="'###.###.###-##'"
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpftitular')"
                        data-vv-name="cpftitular"
                        label="CPF DO TITULAR"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        prepend-inner-icon="mdi-identifier"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field
                        v-mask="'###'"
                        v-model="pagamento.cvv"
                        label="CVV"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        type="password"
                        required
                        v-validate="'required'"
                        :error-messages="errors.collect('codCartao')"
                        data-vv-name="codCartao"
                        prepend-inner-icon="mdi-shield-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2" class="pt-0">
                      <v-select
                        v-model="pagamento.mesVencimento"
                        :items="mesesVencimento"
                        hide-details
                        item-text="titulo"
                        item-value="id"
                        color="#00695C"
                        label="MÊS VENC."
                        v-validate="'required'"
                        :error-messages="errors.collect('expiraCartaoMes')"
                        data-vv-name="expiraCartaoMes"
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar-month"
                        class="mb-3"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="2" class="pt-0">
                      <v-select
                        v-model="pagamento.anoVencimento"
                        :items="anosVencimento"
                        hide-details
                        item-text="titulo"
                        item-value="id"
                        color="#00695C"
                        label="ANO VENC."
                        v-validate="'required'"
                        :error-messages="errors.collect('expiraCartaoAno')"
                        data-vv-name="expiraCartaoAno"
                        outlined
                        dense
                        prepend-inner-icon="mdi-calendar"
                        class="mb-3"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" md="2" class="pt-0">
                      <v-select
                        v-model="pagamento.bandeira"
                        :items="bandeiras"
                        hide-details
                        item-text="text"
                        item-value="value"
                        color="#00695C"
                        label="BANDEIRA"
                        v-validate="'required'"
                        :error-messages="errors.collect('bandeira')"
                        data-vv-name="bandeira"
                        outlined
                        dense
                        prepend-inner-icon="mdi-credit-card"
                        class="mb-3"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" class="pt-0">
                      <v-select
                        v-model="pagamento.valorEscolhido"
                        :items="parcelas"
                        hide-details
                        color="#00695C"
                        label="PARCELAMENTO"
                        v-validate="'required'"
                        :error-messages="errors.collect('parcelas')"
                        data-vv-name="parcelas"
                        @input="carregaQtdParcelas"
                        outlined
                        dense
                        prepend-inner-icon="mdi-cash-multiple"
                        class="mb-3"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="mt-2 mb-0 pb-0">
                      <v-chip
                        x-small
                        color="#E0F2F1"
                        text-color="#00695C"
                        class="mb-2"
                      >
                        <v-icon left size="12" color="#00695C"
                          >mdi-information-outline</v-icon
                        >
                        <span class="text-caption"
                          >Dados de contato e endereço</span
                        >
                      </v-chip>
                    </v-col>

                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field
                        v-mask="'#####-###'"
                        v-model="pagamento.cep"
                        label="CEP"
                        outlined
                        type="tel"
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        prepend-inner-icon="mdi-map-marker-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3" class="pt-0">
                      <v-text-field
                        v-model="pagamento.numero"
                        label="NÚMERO DO ENDEREÇO"
                        outlined
                        type="tel"
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        prepend-inner-icon="mdi-home-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" class="pt-0">
                      <v-text-field
                        v-model="pagamento.email"
                        label="E-MAIL"
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        v-validate="'required'"
                        prepend-inner-icon="mdi-email-outline"
                        class="mb-3"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" class="mb-2">
                      <v-divider class="mb-2"></v-divider>
                      <v-chip
                        x-small
                        color="#E0F2F1"
                        text-color="#00695C"
                        class="mb-2"
                      >
                        <v-icon left size="12" color="#00695C"
                          >mdi-cart-outline</v-icon
                        >
                        <span class="text-caption">Detalhes da Compra</span>
                      </v-chip>
                    </v-col>

                    <v-col cols="12" class="mb-3">
                      <v-card outlined class="elevation-0 pa-3" color="#fafafa">
                        <div
                          class="text-subtitle-1 teal--text text--darken-3 font-weight-medium"
                        >
                          {{ eventoSelecionado.nome }}
                        </div>

                        <v-divider class="my-2"></v-divider>

                        <div class="d-flex align-center my-2">
                          <v-avatar size="24" color="#E0F2F1" class="mr-2">
                            <v-icon size="16" color="#00695C"
                              >mdi-currency-usd</v-icon
                            >
                          </v-avatar>
                          <span class="font-weight-medium text-body-2"
                            >Total:</span
                          >
                          <v-spacer></v-spacer>
                          <span
                            class="teal--text text--darken-3 font-weight-bold text-subtitle-1"
                            v-if="!textoParcela"
                          >
                            {{
                              valorTotalCompra.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            }}
                          </span>
                          <span
                            class="teal--text text--darken-3 font-weight-bold text-subtitle-1"
                            v-else
                          >
                            {{ textoParcela }}
                          </span>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions style="padding: 0px 16px 16px 16px">
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-btn
                        dark
                        block
                        color="#004940"
                        elevation="1"
                        class="py-4 font-weight-medium text-subtitle-2"
                        style="border-radius: 8px"
                        @click="pagamentoCartao"
                      >
                        <v-icon left size="18">mdi-check-circle</v-icon>
                        Finalizar Pagamento
                      </v-btn>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-btn
                        outlined
                        block
                        color="#E53935"
                        class="py-4 font-weight-medium text-subtitle-2"
                        style="border-radius: 8px"
                        @click="cancelarPagamento"
                      >
                        <v-icon left size="18">mdi-close-circle</v-icon>
                        Cancelar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Selecione o evento que você deseja consultar:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select
                        outlined
                        dense
                        v-model="eventoId"
                        :items="eventos"
                        item-text="nome"
                        item-value="id"
                        color="#00695C"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px">
                        Preencha os dados abaixo para consultar a inscrição:
                      </p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field
                        light
                        label="CPF"
                        color="#00695C"
                        outlined
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpf')"
                        data-vv-name="cpf"
                        type="tel"
                        v-model="cpf"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn
                        dark
                        depressed
                        block
                        color="#00695C"
                        style="border-radius: 7px"
                        large
                        @click="consultarInscricao(cpf)"
                        >Consultar Inscrição</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->

        <!-- PÁGINA INSCRIÇÃO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card
              class="login"
              flat
              style="border-radius: 10px; padding: 10px"
            >
              <v-card-text style="padding: 0px">
                <v-container fluid>
                  <v-row justify="space-between" align="center" class="mb-3">
                    <v-col cols="auto" v-if="!bloqueiaVoltar">
                      <v-btn
                        text
                        color="#00695C"
                        @click="retornaPaginaPrincipal"
                        class="px-2"
                      >
                        <v-icon left size="20">mdi-arrow-left</v-icon>
                        <span class="font-weight-medium">Voltar</span>
                      </v-btn>
                    </v-col>

                    <v-col cols="auto">
                      <div class="d-flex align-center">
                        <v-chip
                          color="#E0F2F1"
                          text-color="#00695C"
                          small
                          class="font-weight-medium"
                        >
                          <v-icon left size="16" color="#00695C"
                            >mdi-ticket-outline</v-icon
                          >
                          Ingresso
                        </v-chip>
                        <v-divider vertical class="mx-3" v-if="quantidade.length > 1"></v-divider>
                        <div class="d-flex align-center" v-if="quantidade.length > 1">
                          <span
                            class="text-caption grey--text text--darken-1 mr-2"
                            >Quantidade:</span
                          >
                          <v-select
                            outlined
                            dense
                            hide-details
                            v-model="qtdCompra"
                            :items="quantidade"
                            @input="verificaCapacidade()"
                            style="width: 65px"
                            class="ma-0"
                            color="#00695C"
                          ></v-select>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="indicacao">
                    <v-col cols="12">
                      <v-alert
                        dense
                        color="#E0F2F1"
                        border="left"
                        colored-border
                        class="mb-4"
                        elevation="1"
                      >
                        <div class="d-flex align-center">
                          <v-icon color="#00695C" class="mr-2">mdi-tag</v-icon>
                          <span class="text-body-2">
                            Você está usando o link do divulgador
                            <strong>{{ this.divulgador.nome }}</strong>
                          </span>
                        </div>
                      </v-alert>
                    </v-col>
                  </v-row>

                  <v-row v-if="eventoSelecionado.urlMapa" justify="center">
                    <v-col cols="12" lg="10" class="text-center">
                      <v-card outlined class="elevation-0 pa-0 mb-4">
                        <!-- <v-card-title
                          class="py-2 px-4 subtitle-1 teal--text text--darken-3"
                        >
                          <v-icon left color="#00695C" small
                            >mdi-map-outline</v-icon
                          >
                          Mapa do evento
                        </v-card-title> -->
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                          <img
                            :src="eventoSelecionado.urlMapa"
                            alt="Mapa do Evento"
                            width="100%"
                            style="max-width: 500px; display: inline-block"
                          />
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container
                  fluid
                  grid-list-md
                  v-for="index in qtdCompra"
                  :key="index"
                >
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 class="d-flex align-center mb-2">
                      <v-chip color="#E0F2F1" text-color="#00695C" small>
                        <v-icon left size="16" color="#00695C"
                          >mdi-account</v-icon
                        >
                        <span v-if="qtdCompra != 1"
                          >Dados do {{ index }}º participante</span
                        >
                        <span v-else>Dados do participante</span>
                      </v-chip>

                      <v-spacer></v-spacer>

                      <div
                        v-if="eventoSelecionado.tipoDocumento == 'AMBOS'"
                        class="d-flex align-center"
                      >
                        <v-btn-toggle
                          v-model="inscricao[index - 1].tipoDocumento"
                          mandatory
                          dense
                          color="#00695C"
                          @change="limpaSetor(index - 1)"
                          class="elevation-0"
                        >
                          <v-btn value="CPF" small text> CPF </v-btn>
                          <v-btn value="CNPJ" small text> CNPJ </v-btn>
                        </v-btn-toggle>
                      </div>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg12
                      v-if="
                        eventoSelecionado.desconto != '00,00' &&
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      "
                      class="mb-3"
                    >
                      <v-alert
                        dense
                        color="#4CAF50"
                        dark
                        icon="mdi-tag"
                        border="left"
                      >
                        Desconto de
                        <b>R$ {{ eventoSelecionado.desconto }}</b> aplicado para
                        CNPJ!
                      </v-alert>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg4
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CPF' ||
                        inscricao[index - 1].tipoDocumento == 'CPF'
                      "
                    >
                      <v-text-field
                        label="CPF"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        @change="
                          verificaDocumento(
                            inscricao[index - 1].cpf,
                            index - 1,
                            'CPF'
                          )
                        "
                        prepend-inner-icon="mdi-card-account-details-outline"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg4
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CNPJ' ||
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      "
                    >
                      <v-text-field
                        label="CNPJ"
                        v-model="inscricao[index - 1].cpf"
                        light
                        color="#00695C"
                        outlined
                        v-mask="'##.###.###/####-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        @change="
                          verificaDocumento(
                            inscricao[index - 1].cpf,
                            index - 1,
                            'CNPJ'
                          )
                        "
                        prepend-inner-icon="mdi-office-building-outline"
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg8
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CPF' ||
                        inscricao[index - 1].tipoDocumento == 'CPF'
                      "
                    >
                      <v-text-field
                        label="NOME COMPLETO"
                        v-model="inscricao[index - 1].nome"
                        light
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      lg8
                      v-if="
                        eventoSelecionado.tipoDocumento == 'CNPJ' ||
                        inscricao[index - 1].tipoDocumento == 'CNPJ'
                      "
                    >
                      <v-text-field
                        label="RAZÃO SOCIAL"
                        v-model="inscricao[index - 1].nome"
                        light
                        single-line
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        prepend-inner-icon="mdi-domain"
                      ></v-text-field>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      lg3
                      v-if="inscricao[index - 1].comDesconto"
                    >
                      <v-text-field
                        label="CPF"
                        v-model="inscricao[index - 1].cpfInscricao"
                        light
                        color="#00695C"
                        outlined
                        v-mask="'###.###.###-##'"
                        dense
                        hide-details
                        required
                        type="tel"
                        prepend-inner-icon="mdi-card-account-details-outline"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 class="mt-2 mb-1">
                      <v-divider class="mb-2"></v-divider>
                      <v-chip
                        small
                        color="#E0F2F1"
                        text-color="#00695C"
                        class="mb-2"
                      >
                        <v-icon left size="16" color="#00695C"
                          >mdi-information-outline</v-icon
                        >
                        Informações de contato
                      </v-chip>
                    </v-flex>

                    <!-- <v-flex xs12 sm12 lg3>
                      <v-select
                        label="SEXO"
                        v-model="inscricao[index - 1].sexo"
                        outlined
                        dense
                        :items="sexo"
                        hide-details
                        item-text="titulo2"
                        item-value="id"
                        color="#00695C"
                        prepend-inner-icon="mdi-gender-male-female"
                      ></v-select>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        label="WHATSAPP COM DDD"
                        v-model="inscricao[index - 1].telefone"
                        light
                        color="#00695C"
                        type="tel"
                        outlined
                        hide-details
                        v-mask="'(##) #####-####'"
                        dense
                        required
                        prepend-inner-icon="mdi-whatsapp"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg3>
                      <v-text-field
                        label="E-MAIL"
                        v-model="inscricao[index - 1].email"
                        light
                        outlined
                        color="#00695C"
                        dense
                        hide-details
                        required
                        prepend-inner-icon="mdi-email-outline"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field
                        label="DATA DE NASCIMENTO"
                        v-model="inscricao[index - 1].dataNascimento"
                        light
                        color="#00695C"
                        type="text"
                        outlined
                        hide-details
                        v-mask="'##/##/####'"
                        dense
                        required
                        prepend-inner-icon="mdi-calendar"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 class="mt-2 mb-1">
                      <v-divider class="mb-2"></v-divider>
                      <v-chip
                        small
                        color="#E0F2F1"
                        text-color="#00695C"
                        class="mb-2"
                      >
                        <v-icon left size="16" color="#00695C"
                          >mdi-map-marker</v-icon
                        >
                        Localização
                      </v-chip>
                    </v-flex>

                    <v-flex xs12 sm12 lg6>
                      <v-autocomplete
                        label="ESTADO"
                        v-model="inscricao[index - 1].estado"
                        outlined
                        dense
                        :items="estados"
                        no-data-text="Nenhum estado encontrado"
                        hide-details
                        item-text="nome"
                        item-value="sigla"
                        color="#00695C"
                        :filter="customFilter"
                        prepend-inner-icon="mdi-map"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-autocomplete
                        label="CIDADE"
                        v-model="inscricao[index - 1].cidade"
                        outlined
                        dense
                        :items="retornaMunicipios(inscricao[index - 1].estado)"
                        no-data-text="Nenhuma cidade encontrada"
                        hide-details
                        item-text="municipio-nome"
                        item-value="municipio-nome"
                        color="#00695C"
                        :disabled="
                          inscricao[index - 1].estado != '' ? false : true
                        "
                        :filter="customFilterCidade"
                        prepend-inner-icon="mdi-city"
                      ></v-autocomplete>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg4> -->
                    <!-- <v-select label="SETOR" v-model="inscricao[index-1].setor" outlined dense :items="eventoSelecionado.setores" hide-details :item-text="getItemText" item-value="nome" color="#00695C" @input="calculaValorTotal(inscricao[index-1].setor, index-1)"> -->
                    <!-- <template slot="selection" slot-scope="data">
                          <p style="margin: 0px" v-if="eventoSelecionado.desconto && inscricao[index-1].tipoDocumento == 'CNPJ'">{{ data.item.nome }} (<span style="text-decoration: line-through">R$ {{ data.item.valor }}</span> R$ {{ (parseFloat(data.item.valor.replace(',','.')) - parseFloat(eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',') }})</p>
                          <p style="margin: 0px" v-else>{{ data.item.nome }} (R$ {{ data.item.valor }})</p>
                        </template>
                        <template slot="item" slot-scope="data">
                          <p style="margin: 0px" v-if="eventoSelecionado.desconto && inscricao[index-1].tipoDocumento == 'CNPJ'">{{ data.item.nome }} (<span style="text-decoration: line-through">R$ {{ data.item.valor }}</span> R$ {{ (parseFloat(data.item.valor.replace(',','.')) - parseFloat(eventoSelecionado.desconto.replace(',','.'))).toFixed(2).replace('.',',') }})</p>
                          <p style="margin: 0px" v-else>{{ data.item.nome }} (R$ {{ data.item.valor }})</p>
                        </template> -->
                    <!-- </v-select> -->
                    <!-- </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-divider
                        v-if="index != qtdCompra"
                        style="margin-top: 30px; margin-bottom: 15px"
                      ></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container style="padding: 0px 12px 12px 12px">
                  <v-flex xs12 sm12 lg12>
                    <v-alert
                      color="#E0F2F1"
                      border="left"
                      colored-border
                      elevation="1"
                      dense
                      class="mb-3"
                    >
                      <div class="d-flex align-center">
                        <v-icon color="#00695C" class="mr-2"
                          >mdi-shield-check</v-icon
                        >
                        <div>
                          <v-checkbox
                            v-model="aceiteLgpd"
                            hide-details
                            class="mt-0 pt-0"
                            color="#00695C"
                          >
                            <template v-slot:label>
                              <div class="text-body-2">
                                Concordo com as
                                <a
                                  target="_blank"
                                  href="https://0e7ab606-ac6d-433e-8e2a-ee2a8c8076cb.usrfiles.com/ugd/0e7ab6_a96c417a4eee42959dc91ff125edb6e5.pdf"
                                  class="teal--text text--darken-4"
                                  style="
                                    text-decoration: none;
                                    font-weight: 500;
                                  "
                                  @click.stop
                                  >políticas de privacidade e tratamento de
                                  dados pessoais e regras de cancelamento</a
                                >
                              </div>
                            </template>
                          </v-checkbox>
                        </div>
                      </div>
                    </v-alert>
                  </v-flex>
                </v-container>
                <v-container
                  style="padding: 0px 12px 0px 12px"
                  v-if="eventoSelecionado.urlImgObs"
                >
                  <v-flex xs12 sm12 lg12 style="text-align: center">
                    <img
                      :src="eventoSelecionado.urlImgObs"
                      width="100%"
                      style="max-width: 300px"
                    />
                  </v-flex>
                </v-container>
                <v-container style="padding: 0px 12px 12px 12px">
                  <v-flex xs12 sm12 lg12 class="mb-2">
                    <v-divider class="mb-2"></v-divider>
                    <v-chip
                      x-small
                      color="#E0F2F1"
                      text-color="#00695C"
                      class="mb-2"
                    >
                      <v-icon left size="12" color="#00695C"
                        >mdi-cart-outline</v-icon
                      >
                      <span class="text-caption">Detalhes da Compra</span>
                    </v-chip>
                  </v-flex>

                  <v-flex xs12 sm12 lg12 class="mb-3">
                    <v-card outlined class="elevation-0 pa-3" color="#fafafa">
                      <div
                        class="text-subtitle-1 teal--text text--darken-3 font-weight-medium"
                      >
                        {{ eventoSelecionado.nome }}
                      </div>

                      <v-divider class="my-2"></v-divider>

                      <div
                        v-if="
                          eventoSelecionado.valorPix ||
                          eventoSelecionado.valorCartao
                        "
                      >
                        <div
                          class="d-flex align-center my-2"
                          v-if="eventoSelecionado.valorPix"
                        >
                          <v-avatar size="28" color="#E0F2F1" class="mr-2">
                            <img
                              src="../../assets/pix.png"
                              width="18"
                              alt="pix"
                            />
                          </v-avatar>
                          <span class="font-weight-medium"
                            >Pagamento via Pix:</span
                          >
                          <v-spacer></v-spacer>

                          <div
                            v-if="
                              indicacao &&
                              divulgador.aplicaDesconto &&
                              eventoSelecionado.usaLinkDesconto
                            "
                          >
                            <span
                              class="text-decoration-line-through grey--text text--darken-1"
                            >
                              {{
                                (
                                  parseFloat(
                                    this.eventoSelecionado.valorPix.replace(
                                      ",",
                                      "."
                                    )
                                  ) * this.inscricao.length
                                ).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                })
                              }}
                            </span>
                            <span class="success--text font-weight-bold ml-2">
                              {{
                                valorCompra(
                                  "valorPix",
                                  this.inscricao.length
                                ).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                })
                              }}
                              <v-chip x-small dark color="success" class="ml-1"
                                >{{ divulgador.valorDesconto }}% OFF</v-chip
                              >
                            </span>
                          </div>

                          <div v-else-if="detalhesInscricoes">
                            <span
                              class="text-decoration-line-through grey--text text--darken-1"
                            >
                              {{ detalhesInscricoes.valorOriginal }}
                            </span>
                            <span class="success--text font-weight-bold ml-2">
                              {{ detalhesInscricoes.valorComDesconto }}
                              <v-chip x-small dark color="success" class="ml-1"
                                >{{ detalhesInscricoes.percentualDesconto }}%
                                OFF</v-chip
                              >
                            </span>
                          </div>

                          <div
                            v-else
                            class="teal--text text--darken-3 font-weight-medium"
                          >
                            {{
                              (
                                parseFloat(
                                  this.eventoSelecionado.valorPix.replace(
                                    ",",
                                    "."
                                  )
                                ) * this.inscricao.length
                              ).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            }}
                          </div>
                        </div>

                        <div
                          class="d-flex align-center my-2"
                          v-if="eventoSelecionado.valorCartao"
                        >
                          <v-avatar size="28" color="#E0F2F1" class="mr-2">
                            <img
                              src="../../assets/credit-card.png"
                              width="16"
                              alt="cartão"
                            />
                          </v-avatar>
                          <span class="font-weight-medium"
                            >Pagamento via Cartão:</span
                          >
                          <v-spacer></v-spacer>

                          <div
                            v-if="
                              indicacao &&
                              divulgador.aplicaDesconto &&
                              eventoSelecionado.usaLinkDesconto
                            "
                          >
                            <div
                              class="text-decoration-line-through grey--text text-right"
                            >
                              em até {{ eventoSelecionado.quantidadeParcelas }}x
                              de
                              {{
                                calculaParcelas(eventoSelecionado, qtdCompra)
                              }}
                            </div>
                            <span class="success--text font-weight-bold ml-2">
                              em até {{ eventoSelecionado.quantidadeParcelas }}x
                              de
                              {{
                                calculaParcelasComDesconto(
                                  eventoSelecionado,
                                  qtdCompra
                                )
                              }}
                              <v-chip x-small dark color="success" class="ml-1"
                                >{{ divulgador.valorDesconto }}% OFF</v-chip
                              >
                            </span>
                          </div>

                          <div
                            v-else
                            class="teal--text text--darken-3 font-weight-medium"
                          >
                            em até {{ eventoSelecionado.quantidadeParcelas }}x
                            de
                            {{ calculaParcelas(eventoSelecionado, qtdCompra) }}
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="
                          !eventoSelecionado.valorPix &&
                          !eventoSelecionado.valorCartao
                        "
                        class="d-flex align-center"
                      >
                        <v-avatar size="28" color="#E0F2F1" class="mr-2">
                          <v-icon color="#00695C">mdi-currency-usd</v-icon>
                        </v-avatar>
                        <span class="font-weight-medium">Total:</span>
                        <v-spacer></v-spacer>
                        <span
                          class="teal--text text--darken-3 font-weight-medium"
                        >
                          {{
                            valorTotalCompra.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })
                          }}
                        </span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 mb-3>
                      <v-btn
                        block
                        depressed
                        elevation="1"
                        color="#004940"
                        dark
                        class="text-none py-3 payment-btn d-flex justify-space-between"
                        style="border-radius: 8px"
                        @click="prosseguirPagamento('CARTÃO')"
                      >
                        <div class="d-flex align-center">
                          <v-icon left class="mr-2">mdi-credit-card</v-icon>
                          <span class="font-weight-medium"
                            >Pagar com Cartão</span
                          >
                        </div>
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12>
                      <v-btn
                        block
                        depressed
                        elevation="1"
                        color="#00B1AD"
                        dark
                        class="text-none py-3 payment-btn d-flex justify-space-between"
                        style="border-radius: 8px"
                        @click="prosseguirPagamento('PIX')"
                      >
                        <div class="d-flex align-center">
                          <img
                            src="../../assets/pixnew.png"
                            width="18"
                            class="mr-2"
                            alt="pix"
                            style="filter: brightness(0) invert(1)"
                          />
                          <span class="font-weight-medium">Pagar com Pix</span>
                        </div>
                        <v-icon small>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO -->

        <br />
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAICheckinIntelite.png" width="250px" />
          </a>
        </div>

        <v-dialog
          v-model="dialogoIngressoIndividual"
          persistent
          max-width="600px"
        >
          <v-card
            style="
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
            "
          >
            <div
              style="
                background-color: #2979ff;
                padding: 16px;
                text-align: center;
                border-radius: 10px 10px 0 0;
              "
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon color="white" class="mr-2" size="24"
                  >mdi-ticket-confirmation</v-icon
                >
                <span
                  style="
                    color: white;
                    font-weight: 600;
                    font-size: 18px;
                    letter-spacing: 0.5px;
                  "
                  >Ingresso Digital</span
                >
              </div>
            </div>
            <v-card-text style="padding: 24px 20px; background-color: #ffffff">
              <div style="text-align: center; margin-bottom: 16px">
                <h3
                  style="
                    margin: 0 0 4px 0;
                    color: #1e3a8a;
                    font-size: 20px;
                    font-weight: 600;
                  "
                >
                  {{ inscricaoLocalizada.nome }}
                </h3>
              </div>

              <div
                style="display: flex; justify-content: center; margin: 20px 0"
              >
                <div
                  style="
                    border: 1px solid #e0e7ff;
                    padding: 12px;
                    background-color: #ffffff;
                    border-radius: 12px;
                    display: inline-block;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    "
                  >
                    <enhanced-qr-code
                      :value="inscricaoLocalizada.cod_incricao"
                      :size="150"
                      :margin="1"
                      :borderWidth="8"
                      borderColor="#FFFFFF"
                      :borderRadius="8"
                    ></enhanced-qr-code>
                    <p
                      style="
                        margin: 8px 0 0 0;
                        font-size: 13px;
                        font-weight: 500;
                        color: #4b5563;
                        text-align: center;
                      "
                    >
                      {{ inscricaoLocalizada.cod_incricao }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="inscricaoLocalizada.setor"
                style="
                  margin-top: 20px;
                  background-color: #f8fafc;
                  border-radius: 10px;
                  padding: 16px;
                  border-left: 4px solid #2979ff;
                "
              >
                <div
                  style="
                    font-weight: 500;
                    color: #4b5563;
                    font-size: 14px;
                    margin-bottom: 10px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <v-icon style="color: #2979ff" class="mr-2"
                    >mdi-ticket-confirmation</v-icon
                  >
                  Setor
                </div>
                <div
                  style="display: flex; align-items: center; padding: 0 0 0 4px"
                >
                  <div
                    :style="
                      'width: 16px; height: 16px; border-radius: 50%; background-color: ' +
                      inscricaoLocalizada.corSetor +
                      '; margin-right: 10px; box-shadow: 0 1px 4px rgba(0,0,0,0.1);'
                    "
                  ></div>
                  <span
                    style="font-size: 18px; color: #1f2937; font-weight: 600"
                    >{{ inscricaoLocalizada.setor }}</span
                  >
                </div>
              </div>

              <v-divider
                style="margin: 20px 0; background-color: #e5e7eb"
              ></v-divider>

              <div>
                <div style="display: flex; margin: 10px 0">
                  <v-icon style="margin: 2px 12px 0 0; color: #6b7280"
                    >mdi-calendar</v-icon
                  >
                  <div style="flex: 1; font-size: 15px; color: #374151">
                    {{ inscricaoLocalizada.eventoNome }}
                  </div>
                </div>

                <div style="display: flex; margin: 10px 0">
                  <v-icon style="margin: 2px 12px 0 0; color: #6b7280"
                    >mdi-map-marker</v-icon
                  >
                  <div style="flex: 1; font-size: 15px; color: #374151">
                    {{ inscricaoLocalizada.eventoLocal }}
                    <span v-if="inscricaoLocalizada.eventoLocalizacao">
                      (<a
                        :href="inscricaoLocalizada.eventoLocalizacao"
                        target="_blank"
                        style="color: #2979ff; font-weight: 500"
                        >Ver no mapa</a
                      >)
                    </span>
                  </div>
                </div>
              </div>

              <v-divider
                style="margin: 20px 0; background-color: #e5e7eb"
              ></v-divider>

              <div
                style="
                  display: flex;
                  align-items: center;
                  margin: 10px 0;
                  padding: 12px;
                  background-color: #f0f9ff;
                  border-radius: 8px;
                  border-left: 4px solid #2979ff;
                "
              >
                <v-icon color="#2979FF" class="mr-3" size="22"
                  >mdi-check-circle</v-icon
                >
                <span style="font-weight: 600; color: #1e3a8a"
                  >Pagamento realizado com sucesso!</span
                >
              </div>

              <p
                style="
                  font-size: 13px;
                  color: #6b7280;
                  margin: 12px 0;
                  text-align: left;
                "
              >
                Guarde este comprovante para sua referência no dia do evento
              </p>
            </v-card-text>
            <v-card-actions
              style="padding: 0 20px 20px 20px; background-color: #ffffff"
              v-if="inscricaoLocalizada.eventoUsaCartaoConsumo"
            >
              <v-btn
                style="
                  border-radius: 8px;
                  text-transform: none;
                  height: 44px;
                  font-weight: 500;
                  letter-spacing: 0.3px;
                "
                dark
                depressed
                block
                color="#4B5563"
                :href="
                  'https://aiconsumer.intelite.com.br?cod=' +
                  inscricaoLocalizada.cod_incricao
                "
              >
                <v-icon left>mdi-credit-card-outline</v-icon>
                Cartão Consumo
              </v-btn>
            </v-card-actions>
            <v-card-actions
              style="padding: 0 20px 20px 20px; background-color: #ffffff"
            >
              <v-btn
                style="
                  border-radius: 8px;
                  text-transform: none;
                  height: 44px;
                  font-weight: 500;
                  letter-spacing: 0.3px;
                "
                dark
                depressed
                block
                color="#1565C0"
                @click="dialogoIngressoIndividual = false"
              >
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogoListaIngresso"
          persistent
          max-width="600px"
          scrollable
        >
          <v-card
            style="
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
            "
          >
            <div
              style="
                background-color: #2979ff;
                padding: 16px;
                text-align: center;
                border-radius: 10px 10px 0 0;
              "
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon color="white" class="mr-2" size="24"
                  >mdi-ticket-multiple</v-icon
                >
                <span
                  style="
                    color: white;
                    font-weight: 600;
                    font-size: 18px;
                    letter-spacing: 0.5px;
                  "
                  >Ingressos</span
                >
              </div>
            </div>
            <v-card-text style="padding: 0px 16px; background-color: #ffffff">
              <v-container style="padding: 16px 0px">
                <v-row
                  style="
                    margin: 10px 0;
                    background-color: #f8fafc;
                    border-radius: 8px;
                    padding: 12px;
                  "
                >
                  <v-col cols="12" style="padding: 0px">
                    <p
                      style="
                        margin: 0px;
                        font-weight: 600;
                        color: #1e3a8a;
                        font-size: 16px;
                      "
                    >
                      {{ eventoSelecionado.nome }}
                    </p>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin-top: 4px;
                      "
                    >
                      <v-icon size="18" color="#6B7280" class="mr-2"
                        >mdi-map-marker</v-icon
                      >
                      <span style="color: #4b5563; font-size: 14px"
                        >{{ eventoSelecionado.local }}
                        <span v-if="eventoSelecionado.localizacao">
                          (<a
                            :href="eventoSelecionado.localizacao"
                            target="_blank"
                            style="color: #2979ff; font-weight: 500"
                            >Ver no mapa</a
                          >)
                        </span>
                      </span>
                    </div>
                  </v-col>
                </v-row>

                <v-row
                  align="center"
                  justify="center"
                  v-for="ingresso in inscricao"
                  :key="ingresso.nome"
                  style="
                    border: 1px solid #e0e7ff;
                    margin: 16px 0;
                    border-radius: 10px;
                    background-color: white;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
                  "
                >
                  <v-col cols="12" lg="4" style="padding: 10px">
                    <v-card
                      outlined
                      style="
                        padding: 10px;
                        border-radius: 8px;
                        border-color: #e0e7ff;
                        box-shadow: none;
                      "
                    >
                      <p
                        style="
                          margin: 0 0 8px 0;
                          font-size: 12px;
                          font-weight: 600;
                          color: #4b5563;
                          text-align: center;
                        "
                      >
                        QRCode Ingresso
                      </p>
                      <enhanced-qr-code
                        :value="ingresso.cod_incricao"
                        :size="90"
                        :margin="1"
                        :borderWidth="4"
                        borderColor="#FFFFFF"
                        :borderRadius="4"
                      ></enhanced-qr-code>
                      <p
                        style="
                          margin: 8px 0 0 0;
                          font-size: 11px;
                          font-weight: 500;
                          color: #4b5563;
                          text-align: center;
                        "
                      >
                        {{ ingresso.cod_incricao }}
                      </p>
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="8" style="padding: 10px 16px">
                    <p
                      style="
                        margin: 0px 0 6px 0;
                        font-weight: 600;
                        font-size: 16px;
                        color: #1f2937;
                      "
                    >
                      {{ ingresso.nome }}
                    </p>
                    <p
                      style="
                        margin: 0px 0 12px 0;
                        color: #6b7280;
                        font-size: 14px;
                      "
                    >
                      {{ ingresso.cpf }}
                    </p>
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin: 8px 0 14px 0;
                        background-color: #f8fafc;
                        padding: 8px 10px;
                        border-radius: 6px;
                        border-left: 3px solid #2979ff;
                      "
                    >
                      <div
                        :style="
                          'width: 12px; height: 12px; border-radius: 50%; background-color: ' +
                          ingresso.corSetor +
                          '; margin-right: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);'
                        "
                      ></div>
                      <span
                        style="
                          font-size: 14px;
                          color: #374151;
                          font-weight: 500;
                        "
                      >
                        <span style="color: #6b7280">Setor:</span>
                        {{ ingresso.setor }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions
              style="padding: 0 16px 16px 16px; background-color: #ffffff"
            >
              <v-btn
                style="
                  border-radius: 8px;
                  text-transform: none;
                  height: 44px;
                  font-weight: 500;
                  letter-spacing: 0.3px;
                "
                dark
                depressed
                block
                color="#1565C0"
                @click="dialogoListaIngresso = false"
              >
                <v-icon left>mdi-close-circle-outline</v-icon>
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Fique atento! Após um dia útil, será enviada uma mensagem
                      no WhatsApp do número informado com a confirmação de
                      pagamento e o seu ingresso digital.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px">
                    <v-btn
                      style="border-radius: 7px"
                      dark
                      depressed
                      @click="abreBoleto"
                      >Visualizar Boleto</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#7b4f44"
                @click="closeDialog"
                >fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">{{ msgResultado }}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #ff0000">
                      Sua inscrição foi pré-aprovada. Para confirmar, o
                      pagamento deve ser feito em mãos.
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#7b4f44"
                @click="closeDialog"
                >fechar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 8px">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      {{ inscricao.nome }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto" style="color: #00695c">
                      CPF : {{ inscricao.cpf }}
                    </p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p class="texto">{{ cultoSelecionado }}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px">
                    <p
                      class="texto"
                      style="background-color: #d32f2f; color: white"
                    >
                      Confirme a sua solicitação de cancelamento
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="border-radius: 7px"
                dark
                depressed
                block
                color="#00695C"
                @click="realizarCancelamento"
                >confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px">
            <v-card-title style="justify-content: center; padding: 16px 4px">
              <img
                src="../../assets/pixnew.png"
                width="32"
                height="32"
                alt="Pix"
                class="mr-2"
              />
              <span
                class="texto"
                style="color: #00695c; font-weight: bold; font-size: 20px"
                >{{ msgResultado }}</span
              >
            </v-card-title>

            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" style="padding: 10px">
                    <div class="d-flex align-center mb-2">
                      <img
                        src="../../assets/pixnew.png"
                        width="28"
                        height="28"
                        alt="Pix"
                        class="mr-2"
                      />
                      <span
                        class="texto"
                        style="text-align: left; font-weight: bold"
                      >
                        Copie este código para pagar
                        <b style="color: #00695c"
                          >R$
                          {{
                            (
                              parseFloat(valorTotalCompra) +
                              parseFloat(valorAcrescimo.acrescimoPix)
                            )
                              .toFixed(2)
                              .replace(".", ",")
                          }}</b
                        >:
                      </span>
                    </div>
                    <ol style="text-align: left; padding-left: 16px; margin: 0">
                      <li>Acesse seu app de pagamentos.</li>
                      <li>Escolha pagar via Pix.</li>
                      <li>Cole o seguinte código:</li>
                    </ol>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px">
                    <v-card
                      flat
                      class="d-flex justify-center pa-4"
                      color="white"
                    >
                      <qrcode-vue
                          v-if="exibirQRCode && empresa.gatewayPagamentoPix == 'SICOOB'"
                          :value="qrCode64"
                          :size="200"
                          level="H"
                          bg-color="white"
                      ></qrcode-vue>
                      <img
                        v-else-if="exibirQRCode"
                        :src="qrCode64"
                        width="100%"
                        style="max-width: 300px; border-radius: 8px"
                      />
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    style="padding: 10px 0px 10px 0px"
                  >
                    <v-text-field
                      v-model="chaveCopiaeCola"
                      label="Chave Pix Copia e Cola"
                      id="chavePix"
                      outlined
                      readonly
                      dense
                      class="elevation-0"
                      style="background-color: #f5f5f5; border-radius: 8px"
                    >
                      <template v-slot:prepend>
                        <img
                          src="../../assets/pixnew.png"
                          width="22"
                          height="22"
                          alt="Pix"
                        />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" style="padding-top: 0">
                    <v-btn
                      color="#00695C"
                      dark
                      depressed
                      block
                      height="44"
                      @click="doCopy('chavePix')"
                      class="text-transform-none font-weight-bold"
                      style="border-radius: 8px"
                    >
                      <img
                        src="../../assets/pixnew.png"
                        width="22"
                        height="22"
                        alt="Pix"
                        class="mr-2"
                      />
                      Copiar código Pix
                    </v-btn>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" style="padding-top: 0">
                    <v-btn
                      outlined
                      color="#00695C"
                      block
                      height="44"
                      @click="exibirQRCode = !exibirQRCode"
                      class="text-transform-none"
                      style="border-radius: 8px"
                    >
                      <v-icon left>{{
                        exibirQRCode ? "mdi-eye-off" : "mdi-qrcode"
                      }}</v-icon>
                      {{ exibirQRCode ? "Ocultar QR Code" : "Exibir QR Code" }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px">
            <v-card-text style="text-align: center; padding: 0 24px 0">
              <v-container>
                <p>
                  <b
                    >Enviamos um token para seu WhatsApp.<br />Por favor,
                    informe-o abaixo para ter acesso ao seu ingresso digital:</b
                  >
                </p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px">
                    <v-text-field
                      light
                      v-mask="'####'"
                      v-model="token"
                      label="TOKEN"
                      type="tel"
                      single-line
                      outlined
                      color="#00695C"
                      dense
                      hide-details
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn
                  style="border-radius: 7px"
                  dark
                  block
                  depressed
                  color="#00695C"
                  @click="confirmaToken"
                  >Confirmar</v-btn
                >
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogoInscricaoLocalizada"
          persistent
          max-width="400px"
        >
          <v-card>
            <v-card-title>Inscrição localizada</v-card-title>
            <v-card-text>
              <p>Selecione uma das opções abaixo:</p>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    block
                    depressed
                    color="primary"
                    @click="visualizarIngresso"
                    >Visualizar ingresso</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-btn
                    block
                    depressed
                    color="primary"
                    @click="aplicarDescontoCNPJ"
                    >Aplicar desconto</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false"
          >Fechar</v-btn
        >
      </template>
    </v-snackbar>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#00695C"
      :is-full-page="fullPage"
    ></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
/* import vueCard from 'vue-card-express'; */
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import CpfValidate from "../../componentes/validators/rules/cpf";
import CnpjValidate from "../../componentes/validators/rules/cnpj";
import QrcodeVue from "qrcode.vue";
import EnhancedQrCode from "../../componentes/EnhancedQrCode.vue";
import { baseApiUrl /* modelBoleto */ } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import moment from "moment";
import axios from "axios";
export default {
  components: {
    Snackbar,
    QrcodeVue,
    Loading,
    EnhancedQrCode,
  },
  name: "Auth",

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,

    detalhesInscricoes() {
      let qtdInscricoesCNPJ = this.inscricao.filter(
        (inscricao) => inscricao.tipoDocumento == "CNPJ"
      );

      if (qtdInscricoesCNPJ.length >= 1) {
        let valorOriginal =
          parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) *
          this.inscricao.length;
        let valorComDesconto =
          valorOriginal -
          this.eventoSelecionado.desconto.replace(",", ".") *
            qtdInscricoesCNPJ.length;
        let percentualDesconto = (
          ((valorOriginal - valorComDesconto) / valorOriginal) *
          100
        ).toFixed(0);

        return {
          valorOriginal: valorOriginal.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          valorComDesconto: valorComDesconto.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          percentualDesconto: percentualDesconto,
        };
      }
      return null;
    },
  }),

  data: function () {
    return {
      timeout: 4000,
      snackbar: false,
      textoSnackbar: "",
      pagamentoPix: false,
      localPagamento: "",
      eventoId: "",
      cpf: "",
      email: "",
      qtdCompra: 1,
      pagePrincipal: true,
      pagePagamento: false,
      pageConsulta: false,
      PageIncricao: false,
      maskCartao: "#### #### #### ####",
      user: {},
      cultoSelecionado: "",
      inscricao: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          estado: "",
          cidade: "",
          tipoDocumento: "",
          valorPago: "",
          sebraeCodigoEvento: "",
        },
      ],
      inscricaoDefault: [
        {
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: 0,
          tipo: "VIRTUAL",
          estado: "",
          cidade: "",
          tipoDocumento: "",
          valorPago: "",
          sebraeCodigoEvento: "",
        },
      ],
      pagamento: {
        valor: 0,
        cartaoNumero: "",
        cvv: "",
        mesVencimento: "",
        anoVencimento: "",
        nomeTitular: "",
        cpfTitular: "",
        bandeira: "",
        cep: "",
        numero: "",
        email: "",
      },
      dialogCancelamento: false,
      dialogoIngressoIndividual: false,
      confirmacaoBoleto: false,
      confirmacaoEmMaos: false,
      qtdInscritos: 0,
      capacidadeEvento: 0,
      reserva: 0,
      sexo: ["MASCULINO", "FEMININO"],
      tipo: ["MEMBRO", "VISITANTE"],
      tamanhos: ["PP", "P", "M", "G", "GG", "XG"],
      quantidade: [],
      mesesVencimento: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      anosVencimento: [],
      eventos: [],
      condicoes: [
        { value: true, text: "SIM" },
        { value: false, text: "NÃO" },
      ],
      necessidades: ["AUDITIVA", "CADEIRANTE", "VISUAL"],
      bandeiras: [
        { value: "DINERS", text: "DINERS" },
        { value: "ELO", text: "ELO" },
        { value: "HIPERCARD", text: "HIPERCARD" },
        { value: "MASTERCARD", text: "MASTERCARD" },
        { value: "VISA", text: "VISA" },
      ],
      parcelas: [],
      modelCartao: {
        id: "",
        valor: "",
        tipoTransacao: "A_VISTA",
        quantidadeParcelas: 1,
        comprador: {
          id: "",
          documentoNumero: "",
          documentoTipo: "1",
          email: "",
          nomeCompleto: "",
          primeiroNome: "",
          ultimoNome: "",
          enderecoLogradouro: "",
          enderecoNumero: "",
          enderecoComplemento: "",
          enderecoCep: "",
          enderecoBairro: "",
          enderecoCidade: "",
          enderecoEstado: "",
        },
        cartao: {
          numero: "",
          codigoSeguranca: "",
          nome: "",
          expiracaoAno: "",
          expiracaoMes: "",
          bandeira: "",
        },
      },
      cobrancaAsaas: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
      },
      cobrancaAsaasCartao: {
        customer: "",
        billingType: "",
        value: 0,
        dueDate: "",
        description: "",
        remoteIp: "",
        creditCard: {
          holderName: "",
          number: "",
          expiryMonth: "",
          expiryYear: "",
          ccv: "",
        },
        creditCardHolderInfo: {
          name: "",
          email: "",
          cpfCnpj: "",
          postalCode: "",
          addressNumber: "",
          phone: "",
        },
      },
      clienteAsaas: {
        name: "",
        cpfCnpj: "",
        email: "",
        mobilePhone: "",
        postalCode: "",
        addressNumber: "",
        notificationDisabled: true,
      },
      tokenAsaas:
        "49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3",
      qrCode64: "",
      chaveCopiaeCola: "",
      empresa: [],
      isLoading: false,
      fullPage: true,
      jaExiste: false,
      codigoExistente: "",
      msgResultado: "",
      idInscricao: [],
      codigoAcesso: "",
      informaMunicipio: true,
      idClienteAsaas: "",
      valorAcrescimo: {
        acrescimoBoleto: 0.0,
        acrescimoPix: 0.0,
      },
      qtdInscMasculinas: 0,
      qtdInscFemininas: 0,
      vagasMasculinas: 0,
      vagasFemininas: 0,
      textoParcela: "",
      paginaInscricaoGrupo: false,
      caravana: false,
      inscricaoLocalizada: {
        cod_incricao: "",
        nome: "",
        email: "",
        sexo: "",
        telefone: "",
        eventoNome: "",
        eventoLocal: "",
        eventoLocalizacao: "",
        eventoUsaCartaoConsumo: "",
        setor: "",
        corSetor: "",
      },
      linkBoleto: "",
      consultaCPF: false,
      dialogoToken: false,
      token: "",
      divulgador: [],
      indicacao: false,
      possuiCupom: false,
      exibirQRCode: false,
      cupomDesconto: "",
      cupomAplicado: false,
      loader: null,
      loadingCupom: false,
      dadosCupom: [],
      qtdParcelas: null,
      usaCupomDesconto: null,
      tipoIngresso: "",
      eventoSelecionado: [],
      usaCartaoConsumo: null,
      bloqueiaVoltar: false,
      estados: [],
      municipios: [],
      tiposDocumento: ["CPF", "CNPJ"],
      valorTotalCompra: 0,
      aceiteLgpd: false,
      dialogoListaIngresso: false,
      dialogoInscricaoLocalizada: false,
      dictionary: {
        custom: {
          nomeCartao: {
            required: () => "Informe o nome",
          },
          numCartao: {
            required: () => "Informe o número do cartão de crédito",
          },
          cpftitular: {
            required: () => "Informe o número do cartão de crédito",
          },
          codCartao: {
            required: () => "Informe o código de segurança",
          },
          expiraCartaoMes: {
            required: () => "Informe o mês de validade do cartão",
          },
          expiraCartaoAno: {
            required: () => "Informe o ano de validade do cartão",
          },
          dateOfBirth: {
            required: () => "Informe a Data de Nascimento",
            date_format: () => "Informe uma data válida (dd/mm/aaaa)",
          },
        },
      },
      descricaoExpandida: {},
    };
  },

  mounted: async function () {
    await this.carregaDados();
    this.pegaParametrosUrl();
    this.$validator.localize("pt", this.dictionary);
    this.buscaUfs();
    this.buscaMunicipios();

    // Meta Pixel Code
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    // eslint-disable-next-line no-undef
    fbq("init", "1401322974188502");
    // eslint-disable-next-line no-undef
    fbq("track", "PageView");
  },

  watch: {
    dialogoIngressoIndividual(val) {
      if (val == false) {
        setTimeout(() => {
          let keys = Object.keys(this.inscricaoLocalizada);

          for (let i = 0; i < keys.length; i++) {
            this.inscricaoLocalizada[keys[i]] = "";
          }
        }, 300);
      }
    },

    dialogoListaIngresso(val) {
      if (val == true) {
        // Adicionar parâmetro "confirmed" à URL quando o diálogo é aberto
        const url = new URL(window.location.href);
        const baseUrl = url.origin + url.pathname;
        window.history.pushState({}, "", baseUrl + "/confirmed");

        // Dispara evento de compra para o pixel do Facebook
        // if (typeof fbq !== "undefined") {
        //   // eslint-disable-next-line no-undef
        //   fbq("track", "Purchase", {
        //     value: this.valorTotalCompra,
        //     currency: "BRL",
        //   });
        // }
      } else if (val == false) {
        this.inscricao = Object.assign({}, this.inscricaoDefault);
        this.pagePrincipal = true;
        this.paginaInscricaoGrupo = false;
        this.pagePagamento = false;
        this.idInscricao = [];
      }
    },
  },

  methods: {
    valorCompra(chave, qtdInscricoes) {
      // Valor base
      let valor =
        parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
        qtdInscricoes;

      // Aplicar descontos para CNPJ
      if (this.inscricao && Array.isArray(this.inscricao)) {
        const qtdInscricoesCNPJ = this.inscricao.filter(
          (inscricao) => inscricao.tipoDocumento === "CNPJ"
        ).length;
        if (qtdInscricoesCNPJ > 0 && this.eventoSelecionado.desconto) {
          const descontoCNPJ =
            parseFloat(this.eventoSelecionado.desconto.replace(",", ".")) *
            qtdInscricoesCNPJ;
          valor -= descontoCNPJ;
        }
      }

      // Aplicar desconto do divulgador se aplicável
      if (
        this.indicacao &&
        this.divulgador &&
        this.divulgador.aplicaDesconto &&
        this.eventoSelecionado.usaLinkDesconto
      ) {
        valor -= (valor * this.divulgador.valorDesconto) / 100;
      }

      return valor;
    },

    calculaValorComDesconto(valorOriginal) {
      if (
        !this.indicacao ||
        !this.divulgador ||
        !this.divulgador.aplicaDesconto
      ) {
        return valorOriginal;
      }

      let valor = parseFloat(valorOriginal.replace(",", "."));
      valor -= (valor * this.divulgador.valorDesconto) / 100;

      return valor.toFixed(2).replace(".", ",");
    },

    retornaMunicipios(uf) {
      return this.municipios.filter(
        (municipios) => municipios["UF-sigla"] === uf
      );
    },

    criarQuantidades(minimo, maximo) {
      this.quantidade = [];

      for (let i = 0; i < 51; i++) {
        if (i >= minimo && i <= maximo) {
          this.quantidade.push(i);
        }
      }
    },

    criarAnosVencimento() {
      this.anosVencimento = [];
      let anoAtual = new Date().toISOString().substring(0, 4);
      let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14;

      while (anoAtual <= anoFinal) {
        this.anosVencimento.push((anoAtual++).toString());
      }
    },

    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
        document.execCommand("copy");
        this.snackbar = true;
        this.textoSnackbar = "Chave copiada para a área de transferência!";
      } catch (error) {
        this.snackbar = true;
        this.textoSnackbar =
          "Problema ao copiar chave para a área de transferência";
      }
    },

    reloadPage() {
      window.location.reload();
    },

    async carregaDados() {
      this.eventos = [];
      this.isLoading = true;

      await axios
        .post(baseApiUrl + "eventos/eventosFuturos", {
          empresaId: "6911d6063db8180a3906e90e",
        })
        .then(async (response) => {
          this.eventos = response.data.eventos.filter(
            (evento) => evento.id !== "67b77802df3e5ddb0c43c55e"
          );
          this.empresa = response.data.empresa;

          this.isLoading = false;
        });
    },

    criarParcelas() {
      this.parcelas = [];
      for (let i = 0; i < this.qtdParcelas; i++) {
        // Calcula o valor com acréscimo específico para esta parcela
        const valorAcrescimoAtual =
          parseFloat(
            this.valorAcrescimo["acrescimoCartao" + (i + 1)].replace(",", ".")
          ) || 0;

        // Valor base por inscrição com acréscimo
        let valorBase =
          parseFloat(this.eventoSelecionado.valorCartao.replace(",", ".")) +
          valorAcrescimoAtual;

        // Multiplicar pelo número de inscrições
        let valorTotal = valorBase * this.inscricao.length;

        // Aplicar desconto do divulgador se aplicável
        if (
          this.indicacao &&
          this.divulgador &&
          this.divulgador.aplicaDesconto &&
          this.eventoSelecionado.usaLinkDesconto
        ) {
          valorTotal -= (valorTotal * this.divulgador.valorDesconto) / 100;
        }

        // Aplicar descontos para CNPJ
        const qtdInscricoesCNPJ = this.inscricao.filter(
          (inscricao) => inscricao.tipoDocumento === "CNPJ"
        ).length;
        if (qtdInscricoesCNPJ > 0 && this.eventoSelecionado.desconto) {
          const descontoCNPJ =
            parseFloat(this.eventoSelecionado.desconto.replace(",", ".")) *
            qtdInscricoesCNPJ;
          valorTotal -= descontoCNPJ;
        }

        // Calcular valor da parcela
        const valorParcela = valorTotal / (i + 1);

        this.parcelas.push(
          `${i + 1}X de R$ ${valorParcela
            .toFixed(2)
            .replace(".", ",")} (Total R$ ${valorTotal
            .toFixed(2)
            .replace(".", ",")})`
        );
      }
    },

    cancelarPagamento() {
      //this.removeCupom()
      this.pagePagamento = false;
      if (this.caravana) {
        this.paginaInscricaoGrupo = true;
      } else {
        this.PageIncricao = true;
      }
    },

    /* formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }, */

    formatDatePadrao(date) {
      if (!date) return null;

      const [day, month, year] = date.substr(0, 10).split("/");
      return `${year}-${month}-${day}` + " " + date.substr(11, 6);
    },

    formatDateBrz(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    formatDateHora(date) {
      if (!date) return null;

      const [year, month, day] = date.substr(0, 10).split("-");
      return `${day}/${month}/${year}` + " " + date.substr(11, 8);
    },

    formatDescricao(texto) {
      return texto.replace(/\n/g, "<br>");
    },
    
    mostrarDescricaoResumida(evento) {
      if (!evento.descricao) return '';
      
      // Se a descrição estiver expandida, mostrar o texto completo
      if (this.isDescricaoExpandida(evento.id)) {
        return this.formatDescricao(evento.descricao);
      } 
      
      // Se a descrição for curta, mostrar o texto completo
      if (evento.descricao.length <= 150) {
        return this.formatDescricao(evento.descricao);
      } 
      
      // Caso contrário, mostrar apenas os primeiros 150 caracteres
      const textoResumido = evento.descricao.substring(0, 150);
      return this.formatDescricao(textoResumido + '...');
    },
    
    toggleDescricao(eventoId) {
      this.$set(this.descricaoExpandida, eventoId, !this.isDescricaoExpandida(eventoId));
    },
    
    isDescricaoExpandida(eventoId) {
      return this.descricaoExpandida[eventoId] === true;
    },

    async acessaConsulta() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
    },

    async solicitaCancelamento() {
      this.pagePrincipal = false;
      this.pageConsulta = true;
      if (
        this.inscricao.nome == "" ||
        this.eventoId == "" ||
        this.inscricao.cpf == ""
      ) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = false;
        this.dialogCancelamento = true;
      }
    },

    async realizarCancelamento() {
      this.idInscricao = "";
      this.isLoading = true;
      try {
        let res = await axios.get(
          `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`
        );
        if (res.data[0].id) {
          this.idInscricao = res.data[0].id;
        } else {
          this.isLoading = false;
          this.dialogCancelamento = false;
          var vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#00695C",
            "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      } catch (error) {
        this.isLoading = false;
        this.dialogCancelamento = false;
        vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Não foi possível localizar a inscrição, verifique os dados e tente novamente!",
          "ATENÇÃO"
        );
      }
      if (this.idInscricao != "") {
        try {
          let res = await axios.delete(
            `${baseApiUrl}Inscricoes/${this.idInscricao}`
          );
          if (res.data != "") {
            this.isLoading = false;
            this.inscricao = Object.assign({}, this.inscricaoDefault);
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "Cancelamento realizado com sucesso!",
              "INFORMAÇÃO"
            );
          } else {
            this.isLoading = false;
            this.dialogCancelamento = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
              "ATENÇÃO"
            );
          }
        } catch (error) {
          this.isLoading = false;
          this.dialogCancelamento = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#00695C",
            "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!",
            "ATENÇÃO"
          );
        }
      }
    },

    async aplicaCupom() {
      var vm = this;

      if (this.cupomDesconto) {
        await axios
          .get(
            baseApiUrl +
              'Cupons?filter={"where":{"nome":"' +
              this.cupomDesconto.toUpperCase().trim() +
              '"}}'
          )
          .then((response) => {
            if (response.data) {
              if (
                response.data[0].nome.toUpperCase() ==
                  this.cupomDesconto.toUpperCase().trim() &&
                response.data[0].quantidade > response.data[0].utilizados
              ) {
                this.dadosCupom = response.data[0];
                this.cupomAplicado = true;
                this.valorTotalCompra = parseFloat(
                  parseFloat(this.valorTotalCompra) -
                    parseFloat(this.dadosCupom.valor)
                )
                  .toFixed(2)
                  .replace(".", ",");
              }
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Cupom inválido ou esgotado!",
              "ATENÇÃO"
            );
          });
      }
    },

    removeCupom() {
      this.valorTotalCompra = parseFloat(
        parseFloat(this.valorTotalCompra) + parseFloat(this.dadosCupom.valor)
      )
        .toFixed(2)
        .replace(".", ",");
      this.cupomAplicado = false;
      this.dadosCupom = [];
      this.possuiCupom = false;
      this.cupomDesconto = "";
    },

    async atualizaCupomsUtilizados() {
      await axios.patch(baseApiUrl + "Cupons/" + this.dadosCupom.id, {
        utilizados: this.dadosCupom.utilizados + 1,
      });
    },

    carregaQtdParcelas() {
      for (let i = 0; i < this.parcelas.length; i++) {
        if (this.pagamento.valorEscolhido == this.parcelas[i]) {
          this.cobrancaAsaasCartao.installmentCount = parseInt(
            this.parcelas[i].split("X")[0]
          );
          this.textoParcela = this.parcelas[i];
          this.pagamento.valor = this.parcelas[i]
            .match(/\(Total R\$ ([\d,]+)\)/)[1]
            .replace(",", ".");
          break;
        }
      }
    },

    async prosseguirPagamento(formaPagamento) {
      let vm = this;
      let inscricoesValidas = [];
      await this.pegaVagasDisponiveis();

      if (!this.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Para continuar, concorde com as políticas de privacidade e tratamento de dados pessoais",
          "ATENÇÃO"
        );
        return;
      }

      for (let i = 0; i < this.inscricao.length; i++) {
        this.inscricao[i].setor = this.eventoSelecionado.setores[0].nome;
        this.inscricao[i].corSetor = this.eventoSelecionado.setores[0].cor;
        this.inscricao[i].sebraeCodigoEvento =
          this.eventoSelecionado.sebraeCodigoEvento;

        if (formaPagamento == "CARTÃO") {
          if (
            this.inscricao[i].tipoDocumento == "CNPJ" &&
            this.eventoSelecionado.desconto
          ) {
            this.inscricao[i].valorPago = (
              parseFloat(this.eventoSelecionado.valorCartao.replace(",", ".")) -
              parseFloat(this.eventoSelecionado.desconto.replace(",", "."))
            )
              .toFixed(2)
              .replace(".", ",");
          } else {
            this.inscricao[i].valorPago = this.eventoSelecionado.valorCartao;
          }
        } else if (formaPagamento == "PIX") {
          if (
            (this.inscricao[i].tipoDocumento == "CNPJ" || this.inscricao[i].tipoDocumento == "CPF") &&
            (this.eventoSelecionado.desconto || this.divulgador.aplicaDesconto)
          ) {
            const valorPix = parseFloat(this.eventoSelecionado.valorPix.replace(",", "."));
            const descontoEvento = this.eventoSelecionado.desconto ? parseFloat(this.eventoSelecionado.desconto.replace(",", ".")) : 0;
            const descontoDivulgador = this.divulgador.valorDesconto ? (valorPix * parseFloat(this.divulgador.valorDesconto) / 100) : 0;
            const descontoTotal = descontoEvento + descontoDivulgador;
            this.inscricao[i].valorPago = (valorPix - descontoTotal).toFixed(2).replace(".", ",");
          } else {
            this.inscricao[i].valorPago = this.eventoSelecionado.valorPix;
          }
        }

        // verifica tipoDocumento da inscrição e se todas as informações estão preenchidas
        if (
          this.inscricao[i].tipoDocumento == "CPF" &&
          !this.validarCamposInscricaoCPF(this.inscricao[i])
        ) {
          if (this.inscricao[i].cpf.trim() === "") {
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "CPF do " + (i + 1) + "º participante não foi informado",
              "ATENÇÃO"
            );
            break;
          }
          if (!CpfValidate(this.inscricao[i].cpf)) {
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "CPF informado para o " + (i + 1) + "º participante é inválido",
              "ATENÇÃO"
            );
            break;
          }

          vm.$refs.chamaSnackbar.snack(
            "#00695C",
            "Preencha todos os campos corretamente do " +
              (i + 1) +
              "º participante para confirmar a inscrição!",
            "ATENÇÃO"
          );
          break;
        } else if (
          this.inscricao[i].tipoDocumento == "CNPJ" &&
          !this.validarCamposInscricaoCNPJ(this.inscricao[i])
        ) {
          if (this.inscricao[i].cpf.trim() === "") {
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "CNPJ do " + (i + 1) + "º participante não foi informado",
              "ATENÇÃO"
            );
            break;
          } else if (!CnpjValidate(this.inscricao[i].cpf)) {
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "CNPJ informado para o " + (i + 1) + "º participante é inválido",
              "ATENÇÃO"
            );
            break;
          }

          vm.$refs.chamaSnackbar.snack(
            "#00695C",
            "Preencha todos os campos corretamente do " +
              (i + 1) +
              "º participante para confirmar a inscrição!",
            "ATENÇÃO"
          );
          break;
        } else {
          if (this.vagasDisponiveis[this.inscricao[i].setor] > 0) {
            inscricoesValidas.push(this.inscricao[i]);
          } else {
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "Quantidade máxima do setor selecionado para o " +
                (i + 1) +
                "º participante foi atingido. Selecione outro setor.",
              "ATENÇÃO"
            );
            break;
          }
        }
      }

      if (inscricoesValidas.length === this.inscricao.length) {
        if (formaPagamento == "CARTÃO") {
          if (this.eventoSelecionado.valorCartao) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorCartao");
          }
          this.criarAnosVencimento();
          this.criarParcelas();
          this.pagamento.email = this.inscricao[0].email;
          this.paginaInscricaoGrupo = false;
          this.pagePagamento = true;
        } else if (formaPagamento == "PIX") {
          if (this.eventoSelecionado.valorPix) {
            this.valorTotalCompra = this.calculaValorInscricoes("valorPix");
          }
          if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
            this.pagarPixTaPago();
          } else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
            this.pagarPixSicoob();
          } else {
            this.pagarPixAsaas();
          }
        } else if (formaPagamento == "BOLETO") {
          this.pagamentoBoleto();
        }
      }
    },

    validarCamposInscricaoCPF(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.telefone.trim() === "" ||
        inscricao.valorPago.trim() === ""  ||   
        inscricao.cpf.trim() === "" ||
        !CpfValidate(inscricao.cpf) 
      ) {
        return false;
      } else {
        return true;
      }
    },

    validarCamposInscricaoCNPJ(inscricao) {
      if (
        inscricao.nome.trim() === "" ||
        inscricao.telefone.trim() === "" ||
        inscricao.valorPago.trim() === "" ||
         !CnpjValidate(inscricao.cpf) ||
        inscricao.telefone.trim() === ""
      ) {
        return false;
      } else {
        return true;
      }
    },

    calculaValorInscricoes(chave) {
      // Valor base
      let valor = 0;
      if (this.eventoSelecionado[chave]) {
        valor =
          parseFloat(this.eventoSelecionado[chave].replace(",", ".")) *
          this.inscricao.length;
      }

      // Aplicar descontos para CNPJ
      const qtdInscricoesCNPJ = this.inscricao.filter(
        (inscricao) => inscricao.tipoDocumento === "CNPJ"
      ).length;
      if (qtdInscricoesCNPJ > 0 && this.eventoSelecionado.desconto) {
        const descontoCNPJ =
          parseFloat(this.eventoSelecionado.desconto.replace(",", ".")) *
          qtdInscricoesCNPJ;
        valor -= descontoCNPJ;
      }

      // Aplicar desconto do divulgador se aplicável
      if (
        this.indicacao &&
        this.divulgador &&
        this.divulgador.aplicaDesconto &&
        this.eventoSelecionado.usaLinkDesconto
      ) {
        valor -= (valor * this.divulgador.valorDesconto) / 100;
      }

      return valor;
    },

    async realizarInscricaoPagamento() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.paginaInscricaoGrupo = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.criarAnosVencimento();
            this.criarParcelas();
            this.isLoading = false;
            this.pagePrincipal = false;
            this.PageIncricao = false;
            this.pagePagamento = true;
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoBoleto() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.pagamentoBoleto();
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoEmMaos() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      if (await this.validaVagas()) {
        if (
          this.inscricao.dataNascimento != "" &&
          this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16
        ) {
          this.isLoading = false;
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Só é permitido a inscrição de maiores de 16 anos!",
            "ATENÇÃO"
          );
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf)
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            this.inscricao.statusPagamento = "PENDENTE";
            this.inscricao.formOfPayment = "EM MAOS";
            this.inscricao.valorPago = "330,00";
            this.realizarInscricao(this.finalizaInscricao);
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    async realizarInscricaoPagamentoPix() {
      this.isLoading = true;
      this.jaExiste = false;
      var camposBranco = false;
      this.inscricao.eventoId = this.eventoId;
      var vm = this;
      if (await this.validaVagas()) {
        if (this.caravana) {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.participantes == "" ||
            this.inscricao.dataNascimento == "" ||
            !this.inscricao.aceiteLgpd
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
              this.pagarPixTaPago();
            } else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
              this.pagarPixSicoob();
            } else {
              this.pagarPixAsaas();
            }
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        } else {
          if (
            this.inscricao.nome == "" ||
            this.inscricao.cpf == "" ||
            this.inscricao.telefone == "" ||
            !CpfValidate(this.inscricao.cpf) ||
            this.inscricao.dataNascimento == ""
          ) {
            camposBranco = true;
            this.isLoading = false;
          }
          if (camposBranco) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Preencha todos os campos corretamente para confirmar a inscrição!",
              "ATENÇÃO"
            );
          } else {
            if (this.empresa.gatewayPagamentoPix == "TAPAGO") {
              this.pagarPixTaPago();
            } else if (this.empresa.gatewayPagamentoPix == "SICOOB") {
              this.pagarPixSicoob();
            } else {
              this.pagarPixAsaas();
            }
          }
          if (this.inscricao.length == 0) this.isLoading = false;
        }
      }
    },

    realizarInscricaoAgora() {
      this.pagePrincipal = false;
      this.PageIncricao = true;
      this.validaVagas();
      this.verificaCapacidade();
    },

    async realizarInscricaoGrupo(evento) {
      this.tipoIngresso = evento.nome;
      this.caravana = true;
      this.pagePrincipal = false;
      this.paginaInscricaoGrupo = true;

      this.inscricao = [];
      for (let i = 0; i < evento.vendaMinima; i++) {
        this.inscricao.push({
          cod_incricao: "",
          nome: "",
          cpf: "",
          email: "",
          sexo: "",
          telefone: "",
          eventoId: "",
          lote: "",
          tipo: "VIRTUAL",
          estado: "",
          cidade: "",
          tipoDocumento:
            evento.tipoDocumento == "AMBOS"
              ? evento.documentoPadrao
              : evento.tipoDocumento,
          valorPago: "",
          divulgadorId: this.indicacao ? this.divulgador.id : undefined,
        });
      }

      this.eventoSelecionado = evento;
      this.eventoId = evento.id;
      this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto;
      this.valorAcrescimo.acrescimoPix = evento.acrescimoPix;

      let keys = Object.keys(evento);
      keys = keys.filter((k) => k.includes("acrescimoCartao"));

      for (let i = 0; i < evento.quantidadeParcelas; i++) {
        if (keys[i]) {
          this.valorAcrescimo[keys[i]] = evento[keys[i]];
        } else {
          this.valorAcrescimo["acrescimoCartao" + (i + 1)] = "0,00";
        }
      }

      this.qtdParcelas = evento.quantidadeParcelas;
      this.usaCupomDesconto = evento.usaCupomDesconto;
      this.criarQuantidades(evento.vendaMinima, evento.vendaMaxima);
      this.qtdCompra = Number(evento.vendaMinima);
      // await this.verificaCapacidade()

      for (let i = 0; i < this.inscricao.length; i++) {
        if (evento.tipoDocumento == "AMBOS") {
          this.inscricao[i].tipoDocumento = evento.documentoPadrao;
        } else {
          this.inscricao[i].tipoDocumento = evento.tipoDocumento;
        }
      }

      this.valorTotalCompra = 0;

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async verificaDocumento(cpf, index, tipo) {
      let vm = this;
      let jaExiste = false;

      if (
        (tipo == "CNPJ" && !CnpjValidate(cpf)) ||
        (tipo == "CPF" && !CpfValidate(cpf))
      ) {
        return;
      }

      if (
        !this.eventoSelecionado.desconto &&
        this.verificaCpfInformado(cpf, index)
      ) {
        jaExiste = true;
        this.inscricao[index].cpf = "";
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "CPF/CNPJ não pode ser o mesmo de um já informado!",
          "ATENÇÃO"
        );
      }

      if (!jaExiste) {
        await axios
          .post(baseApiUrl + "inscricoes/consultarInscricaoCPF", {
            cpf: cpf,
            eventoId: this.eventoSelecionado.id,
          })
          .then((response) => {
            if (response.data.length > 0) {
              if (Object.keys(response.data[0]).includes("statusPagamento")) {
                if (response.data[0].statusPagamento == "PAGO") {
                  // exibir diálogo com pergunta de exibir ingresso ou usar cnpj para aplicar desconto (apenas para cnpj)
                  if (
                    response.data[0].eventoNome == this.eventoSelecionado.nome
                  ) {
                    this.inscricaoLocalizada = Object.assign(
                      {},
                      response.data[0]
                    );
                    this.inscricaoLocalizada.indice = index;
                    if (tipo == "CPF") {
                      this.inscricao[index].cpf = "";
                      this.dialogoIngressoIndividual = true;
                    } else {
                      this.dialogoInscricaoLocalizada = true;
                    }
                  } else {
                    this.inscricao[index].cpf = response.data[0].cpf;
                    this.inscricao[index].nome = response.data[0].nome;
                    this.inscricao[index].sexo = response.data[0].sexo;
                    this.inscricao[index].telefone = response.data[0].telefone;
                    this.inscricao[index].email = response.data[0].email;
                    this.inscricao[index].dataNascimento =
                      response.data[0].dataNascimento;
                    this.inscricao[index].estado = response.data[0].estado;
                    this.inscricao[index].cidade = response.data[0].cidade;
                    this.inscricao[index].valorPago =
                      response.data[0].valorPago;
                    // this.inscricao[index].tipoDocumento = response.data[0].tipoDocumento
                  }
                } else if (response.data[0].statusPagamento == "PENDENTE") {
                  this.inscricao[index].cod_incricao =
                    response.data[0].cod_incricao;
                  this.inscricao[index].cpf = response.data[0].cpf;
                  this.inscricao[index].nome = response.data[0].nome;
                  this.inscricao[index].sexo = response.data[0].sexo;
                  this.inscricao[index].telefone = response.data[0].telefone;
                  this.inscricao[index].email = response.data[0].email;
                  this.inscricao[index].dataNascimento =
                    response.data[0].dataNascimento;
                  this.inscricao[index].estado = response.data[0].estado;
                  this.inscricao[index].cidade = response.data[0].cidade;
                  this.inscricao[index].valorPago = response.data[0].valorPago;
                  // this.inscricao[index].tipoDocumento = response.data[0].tipoDocumento
                  this.inscricao[index].id = response.data[0].id;
                }
              } else {
                this.inscricao[index].nome = response.data[0].nome
                  ? response.data[0].nome
                  : "";
                this.inscricao[index].cpf = response.data[0].cpf
                  ? response.data[0].cpf
                  : "";
                this.inscricao[index].dataNascimento = response.data[0]
                  .dataNascimento
                  ? response.data[0].dataNascimento
                  : "";
                this.inscricao[index].telefone = response.data[0].telefone
                  ? response.data[0].telefone
                  : "";
                this.inscricao[index].email = response.data[0].email
                  ? response.data[0].email
                  : "";
                this.inscricao[index].cidade = response.data[0].cidade
                  ? response.data[0].cidade
                  : "";
                this.inscricao[index].estado = response.data[0].estado
                  ? response.data[0].estado
                  : "";
                this.inscricao[index].sexo = response.data[0].sexo
                  ? response.data[0].sexo
                  : "";
              }
            }
          });
      }
    },

    visualizarIngresso() {
      let posicao = this.inscricaoLocalizada.indice;

      this.inscricao[posicao].cpf == "";
      this.dialogoIngressoIndividual = true;
      this.dialogoInscricaoLocalizada = false;
    },

    aplicarDescontoCNPJ() {
      let posicao = this.inscricaoLocalizada.indice;
      this.inscricao[posicao].comDesconto = true;
      this.dialogoInscricaoLocalizada = false;
    },

    verificaCpfInformado(cpf, indice) {
      let cpfLocalizado = false;

      for (let i = 0; i < this.inscricao.length; i++) {
        if (i != indice) {
          if (this.inscricao[i].cpf == cpf) {
            cpfLocalizado = true;
            break;
          }
        }
      }

      return cpfLocalizado;
    },

    async validaVagas() {
      var vm = this;

      try {
        await axios
          .get(
            baseApiUrl +
              'inscricoes/count?where={"and":[{"eventoId":"' +
              this.eventoId +
              '"},{"sexo":"MASCULINO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count;
            }
          });
        await axios
          .get(
            baseApiUrl +
              'inscricoes/count?where={"and":[{"eventoId":"' +
              this.eventoId +
              '"},{"sexo":"FEMININO"}]}'
          )
          .then((response) => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count;
            }
          });
        /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
          if (res.data.length > 0)
            res.data.forEach(insc => {
              if (insc.sexo == 'MASCULINO')
                this.qtdInscMasculinas = this.qtdInscMasculinas + 1
              else if (insc.sexo == 'FEMININO')
                this.qtdInscFemininas = this.qtdInscFemininas + 1
            }); */

        if (this.inscricao.sexo == "MASCULINO") {
          //this.qtdInscMasculinas = this.vagasMasculinas
          if (this.qtdInscMasculinas == this.vagasMasculinas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para homens foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else if (this.inscricao.sexo == "FEMININO") {
          if (this.qtdInscFemininas == this.vagasFemininas) {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#0288D1",
              "Desculpe-nos, todas as vagas para mulheres foram esgotadas!",
              "INFORMAÇÃO"
            );
            return false;
          } else {
            this.isLoading = false;
            return true;
          }
        } else {
          this.isLoading = false;
          return true;
        }
      } catch (error) {
        //
      }
    },

    async realizarInscricao(callback = null, formaPagamento, textoParcela) {
      this.isLoading = true;
      let vm = this;

      for (let i = 0; i < this.inscricao.length; i++) {
        // só preenche com cod_incricao quando for nova inscrição
        if (!this.inscricao[i].cod_incricao) {
          this.inscricao[i].cod_incricao = await this.verificaCodInscricao();
        }

        this.inscricao[i].eventoId = this.eventoSelecionado.id;
        this.inscricao[i].statusPagamento = "PENDENTE";
        this.inscricao[i].empresaId = this.empresa.id;
        this.inscricao[i].email = this.inscricao[i].email.toLowerCase().trim();
        this.inscricao[i].formOfPayment = formaPagamento;
        this.inscricao[i].parcelas = textoParcela;
        this.inscricao[i].divulgadorId = this.indicacao
          ? this.divulgador.id
          : undefined;
        this.inscricao[i].lote = this.eventoSelecionado.lote;

        if (formaPagamento == "CARTAO") {
          // Extrair o valor total da string textoParcela
          const totalMatch = textoParcela.match(/Total R\$ ([\d,.]+)/);
          if (totalMatch) {
            const valorTotal = parseFloat(totalMatch[1].replace('.', '').replace(',', '.'));
            // Dividir o valor total pelo número de inscritos
            const valorPorInscrito = (valorTotal / this.inscricao.length).toFixed(2);
            this.inscricao[i].valorPago = valorPorInscrito.toString().replace('.', ',');
          }
        }

        if (!this.inscricao[i].valorPago) {
          if (formaPagamento == "CARTAO") {
            if (
              this.inscricao[i].tipoDocumento == "CNPJ" &&
              this.eventoSelecionado.desconto
            ) {
              this.inscricao[i].valorPago = (
                parseFloat(
                  this.eventoSelecionado.valorCartao.replace(",", ".")
                ) -
                parseFloat(this.eventoSelecionado.desconto.replace(",", "."))
              )
                .toFixed(2)
                .replace(".", ",");
            } else {
              this.inscricao[i].valorPago = this.eventoSelecionado.valorCartao;
            }
          } else if (formaPagamento == "PIX") {
            if (
              this.inscricao[i].tipoDocumento == "CNPJ" &&
              this.eventoSelecionado.desconto
            ) {
              this.inscricao[i].valorPago = (
                parseFloat(this.eventoSelecionado.valorPix.replace(",", ".")) -
                parseFloat(this.eventoSelecionado.desconto.replace(",", "."))
              )
                .toFixed(2)
                .replace(".", ",");
            } else {
              this.inscricao[i].valorPago = this.eventoSelecionado.valorPix;
            }
          }
        }
      }

      await axios
        .post(baseApiUrl + "inscricoes/criarInscricoes", this.inscricao)
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            for (let j = 0; j < this.inscricao.length; j++) {
              if (this.inscricao[j].nome == response.data[i].nome) {
                this.idInscricao.push(response.data[i].id);
                this.inscricao[j].id = response.data[i].id;
              }
            }
          }

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Erro ao realizar cadastro, tente novamente",
            "ERRO"
          );
        });
    },

    async verificaCodInscricao() {
      let codInscricao = new Date().getTime().toString();
      let codigoRetornado;

      await axios
        .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
          cod_incricao: codInscricao,
        })
        .then(async (response) => {
          if (response.data) {
            await this.verificaCodInscricao();
          }
        })
        .catch((error) => {
          if (error.response.data.error.message.includes("não localizada")) {
            codigoRetornado = codInscricao;
          }
        });

      return codigoRetornado;
    },

    async atualizaInscricao(callback = null) {
      this.inscricao.id = this.idInscricao;
      try {
        await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao);
        if (callback) {
          callback();
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao atualizar cadastro, tente novamente",
          "DESCULPE"
        );
      }
    },

    async enviaEmail() {
      try {
        await axios
          .post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {
            inscricaoId: this.idInscricao,
          })
          .then((res) => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Erro ao enviar e-mail, tente novamente",
          "DESCULPE"
        );
      }
    },

    async realizarConsulta() {
      if (this.cpf == "") {
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para realizar a consulta!",
          "ATENÇÃO"
        );
      } else {
        this.isLoading = true;
        var cpfSemMascara = this.cpf.replaceAll(".", "").replaceAll("-", "");
        await axios
          .get(
            `${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`
          )
          .then((res) => {
            if (res.data != "") {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = "Inscrição localizada";
                this.cultoSelecionado = this.eventos[0].nome;
                this.isLoading = false;
                this.inscricao.nome = res.data[0].nome;
                this.inscricao.cpf = res.data[0].cpf;
                this.inscricao.email = res.data[0].email;
                this.inscricao.ddd = res.data[0].ddd;
                this.inscricao.telefone = res.data[0].telefone;
                this.inscricao.sexo = res.data[0].sexo;
                this.inscricao.participantes = res.data[0].participantes;
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.",
                  "ATENÇÃO"
                );
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome;
                  this.inscricao.nome = res.data[0].nome;
                  this.inscricao.cod_incricao = res.data[0].cod_incricao;
                  this.inscricao.email = res.data[0].email;
                  this.inscricao.participantes = res.data[0].participantes;
                  this.dialogoIngressoIndividual = true;
                  this.isLoading = false;
                }
              }
            } else {
              this.isLoading = false;
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Não foi localizada inscrição para os dados informados!",
                "ATENÇÃO"
              );
            }
          });
      }
    },

    async consultaInscricaoPendente(cpf, indice) {
      this.isLoading = true;

      await axios
        .get(
          baseApiUrl +
            'inscricoes?filter={"where":{"and":[{"eventoId":"' +
            this.eventoId +
            '"},{"cpf":"' +
            cpf +
            '"}]},"include":"evento"}'
        )
        .then((response) => {
          if (response.data) {
            if (response.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true;
              this.msgResultado = "Inscrição localizada";
              this.cultoSelecionado = this.eventos[0].nome;
              this.isLoading = false;
              this.inscricao[indice].cod_incricao =
                response.data[0].cod_incricao;
              this.inscricao[indice].nome = response.data[0].nome;
              this.inscricao[indice].cpf = response.data[0].cpf;
              this.inscricao[indice].email = response.data[0].email;
              this.inscricao[indice].sexo = response.data[0].sexo;
              this.inscricao[indice].telefone = response.data[0].telefone;
              this.inscricao[indice].eventoId = response.data[0].eventoId;
              this.inscricao[indice].codigoTransacao =
                response.data[0].codigoTransacao;
              this.inscricao[indice].estado = response.data[0].estado;
              this.inscricao[indice].cidade = response.data[0].cidade;
              this.inscricao[indice].id = response.data[0].id;
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.",
                "ATENÇÃO"
              );
            } else if (response.data[0].statusPagamento == "PAGO") {
              this.inscricao.cod_incricao = response.data[0].cod_incricao;
              this.cultoSelecionado = response.data[0].evento.nome;
              this.inscricao.participantes = response.data[0].participantes;
              this.inscricao.nome = response.data[0].nome;
              this.codigoAcesso = response.data[0].codigoAcesso;
              this.inscricao.email = response.data[0].email;
              this.dialogoIngressoIndividual = true;
              this.isLoading = false;
            }
          } else {
            this.isLoading = false;
            this.consultaDadosCpf(cpf);
          }
        });
    },

    async consultaDadosCpf(cpf) {
      await axios
        .get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"' + cpf + '"}}')
        .then((response) => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim();
            this.inscricao.dataNascimento = response.data[0].dataNascimento;
            this.inscricao.telefone = response.data[0].telefone;
          }
        });
    },

    async verificaCapacidade() {
      this.isLoading = true;
      let vm = this;

      // clamp por vendaMaxima do evento
      const vendaMaxima = Number((this.eventoSelecionado && this.eventoSelecionado.vendaMaxima) ? this.eventoSelecionado.vendaMaxima : 50);
      if (this.qtdCompra > vendaMaxima) {
        this.qtdCompra = vendaMaxima;
      }

      this.capacidadeEvento = this.eventoSelecionado.vagas;
      this.qtdInscritos =
        this.eventoSelecionado.quantidadeInscricoes +
        this.eventoSelecionado.reserva;

      if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos > 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 1;
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Desculpe-nos, restam apenas " +
            (this.capacidadeEvento - this.qtdInscritos) +
            " vaga(s) disponível!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else if (
        this.qtdInscritos + this.qtdCompra > this.capacidadeEvento &&
        this.capacidadeEvento - this.qtdInscritos == 0
      ) {
        this.isLoading = false;
        this.qtdCompra = 0;
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Desculpe-nos, todas as vagas foram esgotadas!",
          "INFORMAÇÃO"
        );
        this.verificaCapacidade();
      } else {
        this.isLoading = false;
        if (this.qtdCompra > this.inscricao.length) {
          let novasInscricoes = [];

          for (let i = 0; i < this.qtdCompra - this.inscricao.length; i++) {
            novasInscricoes.push({
              cod_incricao: "",
              nome: "",
              cpf: "",
              email: "",
              sexo: "",
              telefone: "",
              eventoId: "",
              lote: "",
              tipo: "VIRTUAL",
              estado: "",
              cidade: "",
              tipoDocumento:
                this.eventoSelecionado.tipoDocumento == "AMBOS"
                  ? this.eventoSelecionado.documentoPadrao
                  : this.eventoSelecionado.tipoDocumento,
              valorPago: "",
            });
          }

          let novaLista = [...this.inscricao, ...novasInscricoes];
          this.inscricao = novaLista;
        } else {
          this.inscricao = this.removerElementos(
            this.inscricao,
            this.inscricao.length - this.qtdCompra
          );
        }
      }
    },

    removerElementos(lista, quantidade) {
      if (lista.length >= quantidade) {
        lista.splice(-quantidade, quantidade);

        return lista;
      }
    },

    async verificaVagas() {
      var vm = this;
      await axios
        .post(`${baseApiUrl}eventos/vagas`, { eventoId: this.eventoId })
        .then((response) => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack(
                  "#00695C",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              } else if (
                response.data.vagasRestantes < this.inscricao.participantes
              ) {
                vm.$refs.chamaSnackbar.snack(
                  "#00695C",
                  "Desculpe-nos, restam apenas " +
                    response.data.vagasRestantes +
                    " vaga(s) disponível(is)!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#00695C",
                  "Desculpe-nos, todas as vagas foram esgotadas!",
                  "INFORMAÇÃO"
                );
                return false;
              }
            }
            return true;
          }
        });
    },

    // método de pagamento
    /* async pagarCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
          await this.realizarInscricao()
          if (this.idInscricao) {
            this.isLoading = true
            var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.inscricao.valorPago = this.valorEvento
            this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
            //dados do comprador
            this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.inscricao.email
            this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
            this.modelCartao.comprador.enderecoNumero = "1734"
            this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
            this.modelCartao.comprador.enderecoCep = "58031130"
            this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
            this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
            this.modelCartao.comprador.enderecoEstado = "PARAIBA"
            // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.nome = this.pagamento.nomeTitular
            // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
            this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
            this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
            this.modelCartao.cartao.bandeira = this.pagamento.bandeira

            // dados para a inscrição
            this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
            this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
            this.inscricao.cardHolderName = this.pagamento.nomeTitular
            this.inscricao.cardFlag = this.pagamento.bandeira
            this.atualizaInscricao()
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data) {
                this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
                this.inscricao.nsu = res.data.transacao.nsu
                this.inscricao.paymentId = res.data.pagamentoId
                this.inscricao.formOfPayment = 'CARTAO'
                this.inscricao.statusPagamento = "PAGO"
                await this.atualizaInscricao()
                this.finalizaInscricao()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
            }
          } else {
            this.isLoading = false
            var vm4 = this;
            vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
          }
        } else {
          this.$validator.validateAll()
        }
      }, */

    /* async pagarBoleto() {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          // criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate())
          // criando nosso número
          var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
          // preencher o campos do modelBoleto
          modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
          modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
          modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
          modelBoleto.pagadorCidade = "JOAO PESSOA"
          modelBoleto.pagadorUf = "PB"
          modelBoleto.pagadorCep = "58031130";
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          // salvando o responsibility e o valor do boleto caso seja anual
          modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
          modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
          modelBoleto.nsu = this.inscricao.cod_incricao
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          // gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.inscricao.boletoId = res.data.id
              this.inscricao.formOfPayment = 'BOLETO'
              this.inscricao.situacaoBoleto = 'GERADO'
              this.inscricao.nsu = modelBoleto.nsu
              this.inscricao.nossoNumero = modelBoleto.nossoNumero
              this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
              this.inscricao.statusPagamento = 'PENDENTE'
              await this.atualizaInscricao()
              await this.imprimirBoleto()
              await this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
            this.close()                 
          }                
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      }, */

    async pagamentoCartao() {
      let vm = this;

      if (
        this.pagamento.nomeTitular != "" &&
        this.pagamento.cartaoNumero != "" &&
        this.pagamento.cpfTitular != "" &&
        this.pagamento.cvv != "" &&
        this.pagamento.mesVencimento != "" &&
        this.pagamento.anoVencimento != "" &&
        this.pagamento.bandeira != "" &&
        this.pagamento.cep != "" &&
        this.pagamento.numero != "" &&
        this.pagamento.email != "" &&
        this.pagamento.valor != 0
      ) {
        this.isLoading = true;

        await this.realizarInscricao(null, "CARTAO", this.textoParcela);
        await this.criarClienteAsaas();
        if (this.idInscricao.length > 0) {
          try {
            let codInscricaoGeral;

            for (let i = 0; i < this.inscricao.length; i++) {
              if (i == 0) {
                codInscricaoGeral = this.inscricao[i].cod_incricao;
              } else {
                codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
              }
            }
            this.cobrancaAsaasCartao.customer = this.idClienteAsaas;
            this.cobrancaAsaasCartao.billingType = "CREDIT_CARD";
            this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor);
            this.cobrancaAsaasCartao.installmentValue = parseFloat(
              parseFloat(this.pagamento.valor) /
                this.cobrancaAsaasCartao.installmentCount
            );
            this.cobrancaAsaasCartao.dueDate = moment().format("YYYY-MM-DD");
            this.cobrancaAsaasCartao.description =
              "Ref. ao evento " +
              this.eventoSelecionado.nome +
              " para as insc. de nº " +
              codInscricaoGeral;
            this.cobrancaAsaasCartao.inscricaoId = this.idInscricao;
            this.cobrancaAsaasCartao.empresaId = this.empresa.id;
            axios.get("https://api.ipify.org/?format=json").then((res) => {
              if (res.data) {
                try {
                  this.cobrancaAsaasCartao.remoteIp = res.data.ip;
                } catch (error) {
                  this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
                }
              } else {
                this.cobrancaAsaasCartao.remoteIp = "127.0.0.1";
              }
            });
            // inserindo dados do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCard.holderName =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCard.number =
              this.pagamento.cartaoNumero;
            this.cobrancaAsaasCartao.creditCard.expiryMonth =
              this.pagamento.mesVencimento;
            this.cobrancaAsaasCartao.creditCard.expiryYear =
              this.pagamento.anoVencimento;
            this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv;
            // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
            this.cobrancaAsaasCartao.creditCardHolderInfo.name =
              this.pagamento.nomeTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.email =
              this.pagamento.email.trim().toLowerCase();
            this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj =
              this.pagamento.cpfTitular;
            this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode =
              this.pagamento.cep;
            this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber =
              this.pagamento.numero;
            this.cobrancaAsaasCartao.creditCardHolderInfo.phone =
              this.inscricao[0].telefone.replace(/[^\d]+/g, "");
            await axios
              .post(
                baseApiUrl + "Pagamentos/AsaasCobranca",
                this.cobrancaAsaasCartao
              )
              .then((response) => {
                if (response.data.cobranca.status == "CONFIRMED") {
                  this.finalizaInscricao();
                  if (this.cupomAplicado) this.atualizaCupomsUtilizados();
                }
              });
          } catch (error) {
            this.idInscricao = [];
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.",
              "DESCULPE"
            );
          }
        } else {
          this.idInscricao = [];
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack(
            "#00695C",
            "Falha ao realizar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        this.$validator.validateAll();
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Preencha todos os campos corretamente para continuar!",
          "ATENÇÃO"
        );
      }
    },

    async criarClienteAsaas() {
      this.clienteAsaas.name = this.pagePagamento
        ? this.pagamento.nomeTitular
        : this.inscricao[0].nome;
      this.clienteAsaas.cpfCnpj = this.pagePagamento
        ? this.pagamento.cpfTitular
        : this.inscricao[0].cpf;
      this.clienteAsaas.email = this.pagamento.email;
      this.clienteAsaas.mobilePhone = this.inscricao[0].telefone.replace(
        /[^\d]+/g,
        ""
      );
      this.clienteAsaas.postalCode = this.pagamento.cep;
      this.clienteAsaas.addressNumber = this.pagamento.numero;
      this.clienteAsaas.empresaId = this.empresa.id;

      try {
        await axios
          .post(baseApiUrl + "Pagamentos/criarCliente", this.clienteAsaas)
          .then((response) => {
            if (response.data) {
              this.idClienteAsaas = response.data.id;
            }
          });
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagamentoBoleto() {
      this.isLoading = true;

      await this.realizarInscricao(null, "BOLETO", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao) {
        let codInscricaoGeral;

        for (let i = 0; i < this.inscricao.length; i++) {
          if (i == 0) {
            codInscricaoGeral = this.inscricao[i].cod_incricao;
          } else {
            codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
          }
        }

        try {
          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra.replace(",", ".")) +
            parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "BOLETO";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.cultoSelecionado +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas)
            .then((res) => {
              if (res.data) {
                this.linkBoleto = res.data.cobranca.bankSlipUrl;
                this.finalizaInscricao();
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Problema encontrado ao gerar o boleto. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    abreBoleto() {
      window.open(this.linkBoleto);
    },

    async pagarPixAsaas() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      await this.criarClienteAsaas();
      if (this.idInscricao.length > 0) {
        try {
          let codInscricaoGeral;

          for (let i = 0; i < this.inscricao.length; i++) {
            if (i == 0) {
              codInscricaoGeral = this.inscricao[i].cod_incricao;
            } else {
              codInscricaoGeral += ", " + this.inscricao[i].cod_incricao;
            }
          }

          this.cobrancaAsaas.customer = this.idClienteAsaas;
          this.cobrancaAsaas.value = (
            parseFloat(this.valorTotalCompra) +
            parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
          ).toFixed(2);
          this.cobrancaAsaas.dueDate = moment().format("YYYY-MM-DD");
          this.cobrancaAsaas.billingType = "PIX";
          this.cobrancaAsaas.description =
            "Ref. ao evento " +
            this.eventoSelecionado.nome +
            " para as insc. de nº " +
            codInscricaoGeral;
          this.cobrancaAsaas.inscricaoId = this.idInscricao;
          this.cobrancaAsaas.empresaId = this.empresa.id;
          await axios
            .post(baseApiUrl + "Pagamentos/AsaasCobranca", this.cobrancaAsaas)
            .then((response) => {
              if (response.data) {
                this.inscricao.codigoTransacao =
                  response.data.cobranca.invoiceUrl;
                this.qrCode64 =
                  "data:image/jpeg;base64," + response.data.qrCode.encodedImage;
                this.chaveCopiaeCola = response.data.qrCode.payload;
                this.msgResultado = "Efetue o pagamento no banco!";
                this.exibirQRCode = true;
                this.pagamentoPix = true;
                this.isLoading = false;
                this.inscricao.id = this.idInscricao;
                this.consultaPagamentoPix(response.data.id);
                if (this.cupomAplicado) this.atualizaCupomsUtilizados();
              }
            });
        } catch (error) {
          this.idInscricao = [];
          this.isLoading = false;
          vm = this;
          vm.$refs.chamaSnackbar.snack(
            "#F9A825",
            "Falha ao gerar pagamento. Tente novamente mais tarde.",
            "DESCULPE"
          );
        }
      } else {
        this.idInscricao = [];
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixSicoob() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let codInscricaoGeral = this.inscricao[0].cod_incricao

        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          calendario: {
            expiracao: 3600
          },
          devedor: {
            cpf: this.inscricao[0].cpf,
            nome: this.inscricao[0].nome,
          },
          valor: {
            original: ""
          },
          chave: "",
          solicitacaoPagador: "Ref. ao evento " + this.eventoSelecionado.nome + " para a insc. de nº " + codInscricaoGeral + ", qtd insc. " + this.inscricao.length
        };

        dadosCobranca.valor.original = (parseFloat(this.valorTotalCompra) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))).toFixed(2);

        await axios.post(baseApiUrl + "Pagamentos/sicoobCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 = response.data.brcode
              this.chaveCopiaeCola = response.data.brcode
              this.msgResultado = "Efetue o pagamento no banco!";
              this.exibirQRCode = true;
              this.pagamentoPix = true;
              this.isLoading = false;
              this.consultaPagamentoPixSicoob();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao gerar pagamento. Tente novamente mais tarde.", "DESCULPE");
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#F9A825", "Falha ao realizar inscrição, tente novamente!", "DESCULPE");
      }
    },

    async consultaPagamentoPixSicoob() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios.post(baseApiUrl + "Pagamentos/sicoobCobrancaConsulta", { "inscricaoId": this.idInscricao[0] })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao('PIX');
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this), 5000);
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack("#EF5350", "Não foi possível verificar o pagamento, tente novamente!", "DESCULPE");
      }
    },

    consultaPagamentoPix() {
      try {
        this.verificaPagamento = setInterval(
          function () {
            axios
              .post(baseApiUrl + "Pagamentos/AsaasCobrancaConsulta", {
                inscricaoId: this.idInscricao[0],
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "RECEIVED") {
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async pagarPixTaPago() {
      this.isLoading = true;

      await this.realizarInscricao(null, "PIX", "A VISTA");
      if (this.idInscricao.length > 0) {
        let dadosCobranca = {
          empresaId: this.empresa.id,
          inscricaoId: this.idInscricao,
          valor: "",
          descricao:
            "Ref. ao evento " +
            this.cultoSelecionado +
            " para a insc. de nº " +
            this.inscricao.cod_incricao,
        };

        dadosCobranca.valor = (
          parseFloat(this.valorTotalCompra) +
          parseFloat(this.valorAcrescimo.acrescimoPix.replace(",", "."))
        ).toFixed(2);

        await axios
          .post(baseApiUrl + "Pagamentos/taPagoCobranca", dadosCobranca)
          .then((response) => {
            if (response.data) {
              this.qrCode64 =
                "data:" +
                response.data.instantPayment.generateImage.mimeType +
                ";base64," +
                response.data.instantPayment.generateImage.imageContent;
              this.chaveCopiaeCola = response.data.instantPayment.textContent;
              this.msgResultado = "Efetue o pagamento no banco!";
              this.exibirQRCode = true;
              this.pagamentoPix = true;
              this.isLoading = false;
              this.atualizaInscricao();
              this.consultaPagamentoPixTaPago();
              if (this.cupomAplicado) this.atualizaCupomsUtilizados();
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm = this;
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Falha ao gerar pagamento. Tente novamente mais tarde.",
              "DESCULPE"
            );
          });
      } else {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Falha ao realizar inscrição, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async consultaPagamentoPixTaPago() {
      try {
        this.verificaPagamento = setInterval(
          async function () {
            await axios
              .post(baseApiUrl + "Pagamentos/taPagoCobrancaConsulta", {
                inscricaoId: this.idInscricao,
                empresaId: this.empresa.id,
              })
              .then((res3) => {
                if (res3.data.status == "APPROVED") {
                  this.isLoading = true;
                  this.finalizaInscricao();
                  clearInterval(this.verificaPagamento);
                }
              });
          }.bind(this),
          5000
        );
      } catch (error) {
        clearInterval(this.verificaPagamento);
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#00695C",
          "Não foi possível verificar o pagamento, tente novamente!",
          "DESCULPE"
        );
      }
    },

    async imprimirBoleto() {
      //Baixando Boleto PDF
      try {
        let res = await axios.get(
          `https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`,
          {
            responseType: "arraybuffer",
            headers: {
              Authorization: "Bearer " + this.token, //the token is a variable which holds the token
              "Content-type": "application/pdf",
            },
          }
        );
        if (res.data) {
          //Create a Blob from the PDF Stream
          const file = new Blob([res.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = fileURL;
          link.setAttribute("download", "boleto.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
          //Open the URL on new Window
          window.open(fileURL);
          //exibe mensagem de conclusao
          this.isLoading = false;
          this.dialogLoading = true;
        }
      } catch (error) {
        this.isLoading = false;
        var vm = this;
        vm.$refs.chamaSnackbar.snack(
          "#EF5350",
          "Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!",
          "ERRO"
        );
      }
    },

    finalizaInscricao() {
      this.isLoading = false;
      if (this.inscricao.formOfPayment == "CARTAO") {
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      } else if (this.inscricao.formOfPayment == "BOLETO") {
        this.msgResultado = "Efetue o pagamento no banco!";
        this.confirmacaoBoleto = true;
      } else if (this.inscricao.formOfPayment == "EM MAOS") {
        this.msgResultado = "Efetue o pagamento no banco!";
        this.confirmacaoEmMaos = true;
      } else {
        this.pagamentoPix = false;
        this.msgResultado = "Compra realizada com sucesso!";
        this.dialogoListaIngresso = true;
      }
    },

    //Função para criptografia
    encrypt(text) {
      let crypto = require("crypto");
      let password = "pxuelh2so839ljis";
      let iv = "pxuelh2so839ljis";
      let cipher = crypto.createCipheriv("aes-128-cbc", password, iv);
      let encryptedData =
        cipher.update(text, "utf8", "Base64") + cipher.final("Base64");
      return encryptedData;
    },

    closeDialog() {
      this.pagamentoPix = false;
      if (!this.consultaCPF) {
        this.reloadPage();
      }
      this.$validator.reset();
      if (this.consultaCPF) {
        this.consultaCPF = false;
        this.inscricao = Object.assign({}, this.inscricaoDefault);
      }
    },

    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.nome;
      const dataB = b.nome;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    calculateAge(dobString) {
      var dob = new Date(dobString);
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var birthdayThisYear = new Date(
        currentYear,
        dob.getMonth(),
        dob.getDate()
      );
      var age = currentYear - dob.getFullYear();
      if (birthdayThisYear > currentDate) {
        age--;
      }
      return age;
    },

    formatDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    async pegaParametrosUrl() {
      var params = window.location.search.substring(1).split("&");
      var vm = this;
      if (params[0] != "") {
        this.isLoading = true;
        let paramArray = {}; // Criar objeto que vai conter os parametros

        for (var i = 0; i < params.length; i++) {
          // Passar por todos os parametros
          var param = params[i].split("="); // Dividir os parametros chave e valor
          paramArray[param[0]] = param[1]; // Adicionar ao objeto criado antes
        }

        if (paramArray["cod"]) {
          await axios
            .post(baseApiUrl + "inscricoes/consultarInscricaoCodigo", {
              cod_incricao: paramArray["cod"],
            })
            .then(async (response) => {
              if (response.data) {
                if (response.data.statusPagamento == "PAGO") {
                  this.inscricaoLocalizada = Object.assign({}, response.data);
                  this.dialogoIngressoIndividual = true;
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Pagamento da inscrição não foi efetuado.",
                    "ATENÇÃO"
                  );
                }
              }
            })
            .catch(() => {
              vm.$refs.chamaSnackbar.snack(
                "#EF5350",
                "Inscrição não localizada!",
                "DESCULPE"
              );
            });
        }
        if (paramArray["d"]) {
          this.consultaDivulgador(paramArray["d"]);
        }
        if (paramArray["e"]) {
          await axios
            .post(baseApiUrl + "eventos/porId", { eventoId: paramArray["e"] })
            .then((response) => {
              if (response.data) {
                if (
                  moment(
                    this.formatDateHora(response.data.fim),
                    "DD/MM/YYYY HH:mm:ss",
                    true
                  ).format() >= moment().format()
                ) {
                  this.bloqueiaVoltar = true;
                  this.realizarInscricaoGrupo(response.data);
                }
              }
            });
        }
      }
      this.isLoading = false;
    },

    async salvaHoraVisualizacao(id) {
      await axios.patch(baseApiUrl + "inscricoes/" + id, {
        visualizado: true,
        ultimaVisualizacao: moment().toISOString(),
      });
    },

    async consultarInscricao(cpf, cod) {
      var vm = this;
      if (cpf) {
        this.isLoading = true;
        let envio = {
          eventoId: this.eventoId,
          cpf: cpf,
          enviaToken: true,
          canalNotificacao: "ZAP",
          cod_incricao: cod,
        };
        try {
          await axios
            .post(`${baseApiUrl}inscricoes/consultarInscricao`, envio)
            .then((response) => {
              if (response.data.length > 0) {
                this.idInscricao = response.data;
                this.dialogoToken = true;
                this.consultaCPF = true;
                this.isLoading = false;
              }
            });
        } catch (error) {
          vm.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Problema ao consultar inscrição, tente novamente!",
            "DESCULPE"
          );
        }
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o CPF para consultar",
          "ATENÇÃO"
        );
      }
    },

    async confirmaToken() {
      var vm = this;
      if (this.token) {
        this.isLoading = true;
        let confirmacao = {
          token: this.token,
          inscricaoId: this.idInscricao,
        };
        await axios
          .post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then((response) => {
            if (response.data) {
              if (response.data.statusPagamento == "PAGO") {
                this.consultaCPF = true;
                this.cultoSelecionado = this.eventos[0].nome;
                this.inscricao.nome = response.data.nome;
                this.inscricao.cod_incricao = response.data.cod_incricao;
                this.inscricao.email = response.data.email;
                this.inscricao.participantes = response.data.participantes;
                this.dialogoToken = false;
                this.token = "";
                this.dialogoIngressoIndividual = true;
                this.isLoading = false;
                this.idInscricao = "";
              } else if (response.data.statusPagamento == "PENDENTE") {
                this.inscricaoLocalizada = true;
                this.consultaInscricao(this.idInscricao);
                if (response.data.participantes > 1) {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoGrupo();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                } else {
                  this.dialogoToken = false;
                  this.isLoading = false;
                  this.pageConsulta = false;
                  this.realizarInscricaoAgora();
                  vm.$refs.chamaSnackbar.snack(
                    "#F9A825",
                    "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.",
                    "ATENÇÃO"
                  );
                }
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "CANCELADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação cancelada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              } else if (response.data.statusPagamento == "ESTORNADO") {
                this.dialogoToken = false;
                this.isLoading = false;
                vm.$refs.chamaSnackbar.snack(
                  "#F9A825",
                  "Foi localizada uma inscrição para este CPF com situação estornada.",
                  "ATENÇÃO"
                );
                this.token = "";
                this.idInscricao = "";
                this.inscricao = Object.assign({}, this.inscricaoDefault);
              }
            } else {
              this.isLoading = false;
              vm.$refs.chamaSnackbar.snack(
                "#F9A825",
                "Token inválido, tente novamente",
                "ATENÇÃO"
              );
            }
          })
          .catch(() => {
            this.isLoading = false;
            vm.$refs.chamaSnackbar.snack(
              "#00695C",
              "Problema ao confirmar token, tente novamente",
              "DESCULPE"
            );
          });
      } else {
        vm.$refs.chamaSnackbar.snack(
          "#F9A825",
          "Informe o token enviado para continuar",
          "ATENÇÃO"
        );
      }
    },

    async consultaInscricao(id) {
      await axios.get(baseApiUrl + "inscricoes/" + id).then((response) => {
        if (response.data) {
          this.inscricao.nome = response.data.nome;
          this.inscricao.cpf = response.data.cpf;
          this.inscricao.dataNascimento = response.data.dataNascimento;
          this.inscricao.telefone = response.data.telefone;
          this.inscricao.possuiNecessidade = response.data.possuiNecessidade;
          this.inscricao.necessidadeEspecial =
            response.data.necessidadeEspecial;
        }
      });
    },

    async consultaDivulgador(id) {
      await axios.get(baseApiUrl + "Divulgadores/" + id).then((response) => {
        if (response.data) {
          if (response.data.ativo) {
            this.indicacao = true;
            this.divulgador = response.data;
            axios.patch(baseApiUrl + "Divulgadores/" + id, {
              qtdClicks: response.data.qtdClicks
                ? response.data.qtdClicks + 1
                : 1,
            });
          }
        }
      });
    },

    retornaData(tipo) {
      return moment().format(tipo);
    },

    retornaPaginaPrincipal() {
      this.eventoSelecionado = [];
      this.inscricao = this.inscricaoDefault;

      if (this.PageIncricao) {
        this.PageIncricao = false;
      } else {
        this.paginaInscricaoGrupo = false;
      }

      this.pagePrincipal = true;
    },

    async buscaUfs() {
      await axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome"
        )
        .then((response) => {
          if (response.data) {
            this.estados = response.data;
          }
        });
    },

    async buscaMunicipios() {
      await axios
        .get(
          "https://servicodados.ibge.gov.br/api/v1/localidades/municipios?view=nivelado"
        )
        .then((response) => {
          if (response.data) {
            this.municipios = response.data;
          }
        });
    },

    getItemText(item) {
      return item.nome;
    },

    calculaValorTotal(setor, indice) {
      let vm = this;

      // localiza o setor escolhido pelo preço e o salva na inscrição
      for (let i = 0; i < this.eventoSelecionado.setores.length; i++) {
        if (this.eventoSelecionado.setores[i].nome == setor) {
          if (
            this.verificaVagaDisponivel(
              this.eventoSelecionado.setores[i].nome
            ) > 0
          ) {
            this.inscricao[indice].valorPago =
              this.eventoSelecionado.setores[i].valor;
            this.inscricao[indice].corSetor =
              this.eventoSelecionado.setores[i].cor;
          } else {
            this.inscricao[indice].valorPago = "";
            this.inscricao[indice].setor = "";
            this.inscricao[indice].corSetor = "";
            vm.$refs.chamaSnackbar.snack(
              "#F9A825",
              "Quantidade máxima atingida para o setor",
              "ATENÇÃO"
            );
          }
          break;
        }
      }

      if (
        this.inscricao[indice].tipoDocumento == "CNPJ" &&
        this.eventoSelecionado.desconto
      ) {
        this.inscricao[indice].valorPago = parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".") -
            this.eventoSelecionado.desconto.replace(",", ".")
        )
          .toFixed(2)
          .replace(".", ",");
      }

      this.valorTotalCompra = 0;

      this.inscricao.forEach((inscricao) => {
        if (inscricao.valorPago) {
          this.valorTotalCompra += parseFloat(
            inscricao.valorPago.replace(",", ".")
          );
        }
      });

      if (this.empresa.limiteInscricao == "SETOR") {
        this.pegaVagasDisponiveis();
      }
    },

    async pegaVagasDisponiveis() {
      await axios
        .post(baseApiUrl + "Empresas/vagasDisponiveis", {
          empresaId: this.empresa.id,
        })
        .then((response) => {
          if (response.data) {
            this.vagasDisponiveis = response.data;
          }

          if (this.inscricao.length > 0) {
            for (let i = 0; i < this.inscricao.length; i++) {
              if (this.inscricao[i].setor) {
                this.vagasDisponiveis[this.inscricao[i].setor] =
                  this.vagasDisponiveis[this.inscricao[i].setor] - 1;
              }
            }
          }
        });
    },

    verificaVagaDisponivel(setor) {
      return this.vagasDisponiveis[setor] - 1;
    },

    limpaSetor(indice) {
      if (this.inscricao[indice].valorPago) {
        this.valorTotalCompra -= parseFloat(
          this.inscricao[indice].valorPago.replace(",", ".")
        );
      }

      this.inscricao[indice].valorPago = "";
      this.inscricao[indice].setor = "";
      this.inscricao[indice].corSetor = "";
    },

    calculaParcelas(evento, qtdCompra) {
      if (!evento) return;

      // Calcular acréscimo da última parcela
      let acrescimo = "0";
      if (evento["acrescimoCartao" + evento.quantidadeParcelas]) {
        acrescimo = evento[
          "acrescimoCartao" + evento.quantidadeParcelas
        ].replace(",", ".");
      }

      // Valor base por inscrição
      let valorBase =
        parseFloat(evento.valorCartao.replace(",", ".")) +
        parseFloat(acrescimo);

      // Multiplicar pela quantidade de compras
      let valorTotal = valorBase;
      if (qtdCompra) {
        valorTotal = valorBase * qtdCompra;
      }

      // Aplicar descontos para CNPJ se estamos na tela de pagamento
      if (this.inscricao && Array.isArray(this.inscricao)) {
        const qtdInscricoesCNPJ = this.inscricao.filter(
          (inscricao) => inscricao.tipoDocumento === "CNPJ"
        ).length;
        if (qtdInscricoesCNPJ > 0 && evento.desconto) {
          const descontoCNPJ =
            parseFloat(evento.desconto.replace(",", ".")) * qtdInscricoesCNPJ;
          valorTotal -= descontoCNPJ;
        }
      }

      // Removendo a aplicação do desconto do divulgador desta função
      // para que o valor riscado mostre o preço sem esse desconto

      // Calcular valor da parcela
      const valorParcela = valorTotal / evento.quantidadeParcelas;

      return valorParcela.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    calculaParcelasComDesconto(evento, qtdCompra) {
      if (!evento) return;

      // Calcular acréscimo da última parcela
      let acrescimo = "0";
      if (evento["acrescimoCartao" + evento.quantidadeParcelas]) {
        acrescimo = evento[
          "acrescimoCartao" + evento.quantidadeParcelas
        ].replace(",", ".");
      }

      // Valor base por inscrição
      let valorBase =
        parseFloat(evento.valorCartao.replace(",", ".")) +
        parseFloat(acrescimo);

      // Multiplicar pela quantidade de compras
      let valorTotal = valorBase;
      if (qtdCompra) {
        valorTotal = valorBase * qtdCompra;
      }

      // Aplicar descontos para CNPJ se estamos na tela de pagamento
      if (this.inscricao && Array.isArray(this.inscricao)) {
        const qtdInscricoesCNPJ = this.inscricao.filter(
          (inscricao) => inscricao.tipoDocumento === "CNPJ"
        ).length;
        if (qtdInscricoesCNPJ > 0 && evento.desconto) {
          const descontoCNPJ =
            parseFloat(evento.desconto.replace(",", ".")) * qtdInscricoesCNPJ;
          valorTotal -= descontoCNPJ;
        }
      }

      // Aplicar desconto do divulgador se aplicável
      if (
        this.indicacao &&
        this.divulgador &&
        this.divulgador.aplicaDesconto &&
        evento.usaLinkDesconto
      ) {
        valorTotal -= (valorTotal * this.divulgador.valorDesconto) / 100;
      }

      // Calcular valor da parcela
      const valorParcela = valorTotal / evento.quantidadeParcelas;

      return valorParcela.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    fazerUpgrade(cod_inscricao) {
      window.location.href = `https://aicheckin.com.br/up?cod=${cod_inscricao}`;
    },

    customFilter(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedItem = this.normalizeText(item.nome);

      return normalizedItem.indexOf(normalizedQuery) > -1;
    },

    normalizeText(text) {
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    customFilterCidade(item, queryText) {
      const normalizedQuery = this.normalizeText(queryText);
      const normalizedItem = this.normalizeText(item["municipio-nome"]);

      return normalizedItem.indexOf(normalizedQuery) > -1;
    },
  },
};
</script>

<style scoped>
/* LOGIN */

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #000000, #000000);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 0px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.no-break {
  word-wrap: normal; /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
  word-break: keep-all; /* Isso também ajuda a prevenir a quebra no meio de palavras */
  white-space: pre-line; /* Isto vai respeitar os espaços em branco e quebras de linha */
}

a {
  text-decoration: none;
}

.event-container {
  margin-bottom: 40px;
}

.v-card.mx-auto {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.v-card.mx-auto:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.price-section {
  margin-top: 16px;
}

.text-decoration-underline {
  text-decoration: underline;
}

.text-transform-none {
  text-transform: none !important;
  letter-spacing: 0.5px;
}

.v-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 105, 92, 0.2) !important;
}

.v-btn:active {
  transform: translateY(0);
}

.v-card.flat {
  transition: all 0.3s ease;
}

.v-card.flat:hover {
  background-color: #eaeaea !important;
}

.success--text {
  color: #4caf50 !important;
}

.v-card-title {
  word-break: normal;
  white-space: normal;
}

.qr-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.qr-container img,
.qr-container enhanced-qr-code {
  border: 10px solid white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.pix-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #4bb8a9;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.payment-btn {
  transition: all 0.3s ease;
}
.payment-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
}

.evento-descricao {
  position: relative;
  width: 100%;
}

.descricao-container {
  transition: max-height 0.3s ease;
  overflow: hidden;
}

.descricao-container.expandida {
  max-height: none !important;
}

.descricao-texto {
  word-break: break-word;
  line-height: 1.5;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
}

@media (max-width: 600px) {
  .descricao-texto {
    font-size: 13px;
  }
}
</style>
